import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

const Web = ({ step }: { step: number }): JSX.Element => {
  return (
    <Wrap className={step !== 1 ? '' : ''}>
      {step === 1 && (
        <>
          <svg
            id="banner_web_circle_icon"
            width="652"
            height="518"
            viewBox="0 0 652 518"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g
              id="banner_web_circle_item_4"
              transform="scale(0)"
              className="banner_web_circle_item"
            >
              <path
                opacity="0.5"
                d="M452 84C475.196 84 494 65.196 494 42C494 18.804 475.196 0 452 0C428.804 0 410 18.804 410 42C410 65.196 428.804 84 452 84Z"
                fill="url(#paint0_radial_2166_8147)"
              />
              <path
                opacity="0.65"
                d="M452 74C469.673 74 484 59.6731 484 42C484 24.3269 469.673 10 452 10C434.327 10 420 24.3269 420 42C420 59.6731 434.327 74 452 74Z"
                fill="url(#paint1_radial_2166_8147)"
              />
              <path
                d="M477.829 41.9999C477.829 56.265 466.265 67.8292 452 67.8292C437.735 67.8292 426.171 56.265 426.171 41.9999C426.171 27.7348 437.735 16.1706 452 16.1706C466.265 16.1706 477.829 27.7348 477.829 41.9999Z"
                fill="#444052"
                fillOpacity="0.5"
                stroke="#D76FFC"
                strokeWidth="1.1625"
              />
              <path
                d="M464.934 42.8613C464.632 42.506 464.303 42.1506 463.952 41.7965C464.193 41.543 464.423 41.289 464.64 41.0351C466.876 38.4098 467.511 36.0282 466.427 34.3292C465.344 32.6301 462.749 31.9372 459.119 32.378C458.737 32.4245 458.346 32.4834 457.949 32.5534C457.814 32.196 457.671 31.8498 457.52 31.5167C456.127 28.4505 454.167 26.7618 452 26.7618C449.833 26.7618 447.873 28.4505 446.48 31.5167C446.328 31.8498 446.185 32.196 446.05 32.5534C445.654 32.4835 445.263 32.4245 444.88 32.378C441.251 31.9373 438.656 32.6301 437.572 34.3292C436.489 36.0282 437.124 38.4098 439.36 41.0351C439.576 41.289 439.806 41.543 440.048 41.7965C439.697 42.1506 439.368 42.5059 439.066 42.8613C436.829 45.4867 436.194 47.8683 437.278 49.5673C438.148 50.9324 439.994 51.6479 442.569 51.6479C443.199 51.6479 443.872 51.6051 444.586 51.5184C445.045 51.4626 445.516 51.389 445.996 51.2994C446.147 51.7092 446.308 52.1047 446.48 52.4833C447.873 55.5494 449.833 57.238 452 57.238C454.167 57.238 456.127 55.5494 457.52 52.4832C457.692 52.1046 457.853 51.7091 458.004 51.2993C458.484 51.3889 458.955 51.4626 459.414 51.5183C460.128 51.605 460.801 51.6479 461.431 51.6479C464.005 51.6479 465.852 50.9323 466.722 49.5672C467.805 47.8682 467.17 45.4867 464.934 42.8613V42.8613ZM461.147 34.0312C462.95 34.0312 464.224 34.4456 464.719 35.222C465.367 36.2379 464.769 37.9592 463.078 39.9445C462.917 40.1337 462.747 40.323 462.57 40.5122C461.582 39.6605 460.469 38.8272 459.258 38.033C459.091 36.7106 458.839 35.4469 458.511 34.272C459.476 34.1107 460.362 34.0312 461.147 34.0312V34.0312ZM454.618 46.2852C453.732 46.7486 452.857 47.1643 452.001 47.5339C451.144 47.1642 450.269 46.7489 449.382 46.2852C448.403 45.7736 447.467 45.2322 446.583 44.6698C446.509 43.8157 446.469 42.9244 446.469 41.9999C446.469 40.9643 446.519 39.9702 446.612 39.0236C447.399 38.5338 448.227 38.0609 449.087 37.6112C450.076 37.0944 451.05 36.6376 452 36.2372C452.95 36.6376 453.924 37.0944 454.913 37.6112C455.773 38.0609 456.6 38.5338 457.388 39.0236C457.481 39.9702 457.531 40.9643 457.531 41.9999C457.531 42.9244 457.491 43.8157 457.416 44.6698C456.533 45.2322 455.597 45.7736 454.618 46.2852V46.2852ZM457.116 47.0002C456.983 47.7603 456.823 48.4803 456.639 49.1551C455.908 48.9626 455.146 48.7298 454.359 48.4554C454.775 48.2555 455.191 48.0478 455.604 47.8317C456.119 47.5624 456.623 47.2847 457.116 47.0002ZM449.64 48.4554C448.854 48.7298 448.092 48.9624 447.361 49.1548C447.177 48.4802 447.016 47.7602 446.884 47.0002C447.377 47.2847 447.881 47.5624 448.396 47.8316C448.809 48.0478 449.224 48.2555 449.64 48.4554ZM444.521 43.2466C443.896 42.7782 443.311 42.3009 442.771 41.8192C443.318 41.3467 443.908 40.8795 444.535 40.4213C444.51 40.9424 444.497 41.4691 444.497 41.9999C444.497 42.4183 444.505 42.834 444.521 43.2466ZM446.939 36.6968C447.071 35.9854 447.229 35.3109 447.407 34.6774C448.108 34.8548 448.838 35.07 449.592 35.3236C449.094 35.559 448.596 35.8061 448.101 36.0648C447.707 36.2708 447.32 36.4818 446.939 36.6968V36.6968ZM454.408 35.3236C455.162 35.0699 455.892 34.8546 456.593 34.6774C456.771 35.3109 456.929 35.9854 457.061 36.6968C456.68 36.4818 456.293 36.2708 455.899 36.0648C455.404 35.806 454.906 35.559 454.408 35.3236ZM459.465 40.4213C460.092 40.8795 460.681 41.3467 461.229 41.8192C460.689 42.3009 460.103 42.7782 459.479 43.2466C459.495 42.834 459.503 42.4183 459.503 41.9999C459.503 41.469 459.49 40.9424 459.465 40.4213V40.4213ZM452 28.5476C453.426 28.5476 454.942 30.1906 456.025 32.97C454.72 33.3021 453.367 33.7424 452 34.2806C450.633 33.7424 449.28 33.3021 447.975 32.97C449.058 30.1906 450.573 28.5476 452 28.5476ZM439.28 35.222C439.776 34.4455 441.049 34.0313 442.852 34.0313C443.638 34.0313 444.524 34.1107 445.489 34.2721C445.16 35.447 444.909 36.7107 444.742 38.0331C443.531 38.8273 442.418 39.6606 441.429 40.5123C441.253 40.323 441.083 40.1337 440.922 39.9446C439.231 37.9593 438.633 36.238 439.28 35.222ZM442.558 49.8651C440.755 49.865 439.481 49.4508 438.986 48.6744C438.338 47.6584 438.936 45.9371 440.627 43.9518C440.868 43.6689 441.127 43.3857 441.403 43.103C442.38 43.9731 443.49 44.8266 444.703 45.6416C444.862 47.0265 445.113 48.3512 445.448 49.5807C444.384 49.7718 443.411 49.8652 442.558 49.8651V49.8651ZM452 55.4523C450.546 55.4523 448.999 53.7446 447.913 50.8665C449.24 50.5173 450.614 50.0573 452 49.4983C453.386 50.0573 454.76 50.5173 456.087 50.8665C455 53.7446 453.454 55.4523 452 55.4523ZM465.014 48.6744C464.285 49.8184 461.865 50.1757 458.552 49.5807C458.887 48.3512 459.137 47.0265 459.297 45.6416C460.51 44.8266 461.62 43.9731 462.597 43.103C462.873 43.3857 463.132 43.669 463.372 43.9518C465.064 45.9371 465.662 47.6584 465.014 48.6744Z"
                fill="white"
              />
              <path
                d="M452 44.7588C453.683 44.7588 455.047 43.5236 455.047 41.9999C455.047 40.4762 453.683 39.241 452 39.241C450.317 39.241 448.953 40.4762 448.953 41.9999C448.953 43.5236 450.317 44.7588 452 44.7588Z"
                fill="white"
              />
              <g filter="url(#filter0_f_2166_8147)">
                <path
                  d="M464.934 42.8613C464.632 42.506 464.303 42.1506 463.952 41.7965C464.193 41.543 464.423 41.289 464.64 41.0351C466.876 38.4098 467.511 36.0282 466.427 34.3292C465.344 32.6301 462.749 31.9372 459.119 32.378C458.737 32.4245 458.346 32.4834 457.949 32.5534C457.814 32.196 457.671 31.8498 457.52 31.5167C456.127 28.4505 454.167 26.7618 452 26.7618C449.833 26.7618 447.873 28.4505 446.48 31.5167C446.328 31.8498 446.185 32.196 446.05 32.5534C445.654 32.4835 445.263 32.4245 444.88 32.378C441.251 31.9373 438.656 32.6301 437.572 34.3292C436.489 36.0282 437.124 38.4098 439.36 41.0351C439.576 41.289 439.806 41.543 440.048 41.7965C439.697 42.1506 439.368 42.5059 439.066 42.8613C436.829 45.4867 436.194 47.8683 437.278 49.5673C438.148 50.9324 439.994 51.6479 442.569 51.6479C443.199 51.6479 443.872 51.6051 444.586 51.5184C445.045 51.4626 445.516 51.389 445.996 51.2994C446.147 51.7092 446.308 52.1047 446.48 52.4833C447.873 55.5494 449.833 57.238 452 57.238C454.167 57.238 456.127 55.5494 457.52 52.4832C457.692 52.1046 457.853 51.7091 458.004 51.2993C458.484 51.3889 458.955 51.4626 459.414 51.5183C460.128 51.605 460.801 51.6479 461.431 51.6479C464.005 51.6479 465.852 50.9323 466.722 49.5672C467.805 47.8682 467.17 45.4867 464.934 42.8613V42.8613ZM461.147 34.0312C462.95 34.0312 464.224 34.4456 464.719 35.222C465.367 36.2379 464.769 37.9592 463.078 39.9445C462.917 40.1337 462.747 40.323 462.57 40.5122C461.582 39.6605 460.469 38.8272 459.258 38.033C459.091 36.7106 458.839 35.4469 458.511 34.272C459.476 34.1107 460.362 34.0312 461.147 34.0312V34.0312ZM454.618 46.2852C453.732 46.7486 452.857 47.1643 452.001 47.5339C451.144 47.1642 450.269 46.7489 449.382 46.2852C448.403 45.7736 447.467 45.2322 446.583 44.6698C446.509 43.8157 446.469 42.9244 446.469 41.9999C446.469 40.9643 446.519 39.9702 446.612 39.0236C447.399 38.5338 448.227 38.0609 449.087 37.6112C450.076 37.0944 451.05 36.6376 452 36.2372C452.95 36.6376 453.924 37.0944 454.913 37.6112C455.773 38.0609 456.6 38.5338 457.388 39.0236C457.481 39.9702 457.531 40.9643 457.531 41.9999C457.531 42.9244 457.491 43.8157 457.416 44.6698C456.533 45.2322 455.597 45.7736 454.618 46.2852V46.2852ZM457.116 47.0002C456.983 47.7603 456.823 48.4803 456.639 49.1551C455.908 48.9626 455.146 48.7298 454.359 48.4554C454.775 48.2555 455.191 48.0478 455.604 47.8317C456.119 47.5624 456.623 47.2847 457.116 47.0002ZM449.64 48.4554C448.854 48.7298 448.092 48.9624 447.361 49.1548C447.177 48.4802 447.016 47.7602 446.884 47.0002C447.377 47.2847 447.881 47.5624 448.396 47.8316C448.809 48.0478 449.224 48.2555 449.64 48.4554ZM444.521 43.2466C443.896 42.7782 443.311 42.3009 442.771 41.8192C443.318 41.3467 443.908 40.8795 444.535 40.4213C444.51 40.9424 444.497 41.4691 444.497 41.9999C444.497 42.4183 444.505 42.834 444.521 43.2466ZM446.939 36.6968C447.071 35.9854 447.229 35.3109 447.407 34.6774C448.108 34.8548 448.838 35.07 449.592 35.3236C449.094 35.559 448.596 35.8061 448.101 36.0648C447.707 36.2708 447.32 36.4818 446.939 36.6968V36.6968ZM454.408 35.3236C455.162 35.0699 455.892 34.8546 456.593 34.6774C456.771 35.3109 456.929 35.9854 457.061 36.6968C456.68 36.4818 456.293 36.2708 455.899 36.0648C455.404 35.806 454.906 35.559 454.408 35.3236ZM459.465 40.4213C460.092 40.8795 460.681 41.3467 461.229 41.8192C460.689 42.3009 460.103 42.7782 459.479 43.2466C459.495 42.834 459.503 42.4183 459.503 41.9999C459.503 41.469 459.49 40.9424 459.465 40.4213V40.4213ZM452 28.5476C453.426 28.5476 454.942 30.1906 456.025 32.97C454.72 33.3021 453.367 33.7424 452 34.2806C450.633 33.7424 449.28 33.3021 447.975 32.97C449.058 30.1906 450.573 28.5476 452 28.5476ZM439.28 35.222C439.776 34.4455 441.049 34.0313 442.852 34.0313C443.638 34.0313 444.524 34.1107 445.489 34.2721C445.16 35.447 444.909 36.7107 444.742 38.0331C443.531 38.8273 442.418 39.6606 441.429 40.5123C441.253 40.323 441.083 40.1337 440.922 39.9446C439.231 37.9593 438.633 36.238 439.28 35.222ZM442.558 49.8651C440.755 49.865 439.481 49.4508 438.986 48.6744C438.338 47.6584 438.936 45.9371 440.627 43.9518C440.868 43.6689 441.127 43.3857 441.403 43.103C442.38 43.9731 443.49 44.8266 444.703 45.6416C444.862 47.0265 445.113 48.3512 445.448 49.5807C444.384 49.7718 443.411 49.8652 442.558 49.8651V49.8651ZM452 55.4523C450.546 55.4523 448.999 53.7446 447.913 50.8665C449.24 50.5173 450.614 50.0573 452 49.4983C453.386 50.0573 454.76 50.5173 456.087 50.8665C455 53.7446 453.454 55.4523 452 55.4523ZM465.014 48.6744C464.285 49.8184 461.865 50.1757 458.552 49.5807C458.887 48.3512 459.137 47.0265 459.297 45.6416C460.51 44.8266 461.62 43.9731 462.597 43.103C462.873 43.3857 463.132 43.669 463.372 43.9518C465.064 45.9371 465.662 47.6584 465.014 48.6744Z"
                  fill="white"
                />
                <path
                  d="M452 44.7588C453.683 44.7588 455.047 43.5236 455.047 41.9999C455.047 40.4762 453.683 39.241 452 39.241C450.317 39.241 448.953 40.4762 448.953 41.9999C448.953 43.5236 450.317 44.7588 452 44.7588Z"
                  fill="white"
                />
              </g>
            </g>
            <animateTransform
              xlinkHref="#banner_web_circle_item_4"
              begin="2s"
              dur="0.5s"
              attributeName="transform"
              type="scale"
              values="0; 0.5; 1.04; 1"
              fill="freeze"
            />

            <g
              id="banner_web_circle_item_3"
              transform="scale(0)"
              className="banner_web_circle_item"
            >
              <path
                opacity="0.5"
                d="M155 99C178.196 99 197 80.1959 197 57C197 33.804 178.196 15 155 15C131.804 15 113 33.804 113 57C113 80.1959 131.804 99 155 99Z"
                fill="url(#paint2_radial_2166_8147)"
              />
              <path
                opacity="0.65"
                d="M155 89C172.673 89 187 74.6731 187 57C187 39.3269 172.673 25 155 25C137.327 25 123 39.3269 123 57C123 74.6731 137.327 89 155 89Z"
                fill="url(#paint3_radial_2166_8147)"
              />
              <path
                d="M180.829 57C180.829 71.2652 169.265 82.8293 155 82.8293C140.735 82.8293 129.171 71.2652 129.171 57C129.171 42.7349 140.735 31.1707 155 31.1707C169.265 31.1707 180.829 42.7349 180.829 57Z"
                fill="#444052"
                fillOpacity="0.5"
                stroke="#D76FFC"
                strokeWidth="1.1625"
              />
              <g filter="url(#filter1_f_2166_8147)">
                <path
                  d="M163.164 57.9396C163.123 54.0824 166.25 52.2252 166.391 52.1353C164.627 49.5186 161.889 49.1639 160.913 49.1214C158.581 48.8843 156.366 50.5253 155.184 50.5267C154.003 50.5282 152.175 49.1696 150.243 49.2091C147.701 49.25 145.362 50.7192 144.055 53.0363C141.423 57.7035 143.396 64.6078 145.973 68.3869C147.232 70.2341 148.734 72.3136 150.702 72.236C152.599 72.1584 153.314 70.9855 155.604 70.9823C157.895 70.9789 158.542 72.2251 160.547 72.1842C162.587 72.1442 163.877 70.2932 165.123 68.436C166.564 66.2865 167.155 64.206 167.19 64.0993C167.146 64.0788 163.211 62.5492 163.164 57.9396Z"
                  fill="white"
                />
                <path
                  d="M159.401 46.6272C160.446 45.3381 161.15 43.5467 160.957 41.762C159.452 41.8244 157.629 42.7834 156.548 44.0705C155.58 45.2115 154.731 47.0349 154.96 48.7843C156.639 48.9158 158.355 47.9143 159.401 46.6272Z"
                  fill="white"
                />
              </g>
              <path
                d="M163.164 57.9396C163.123 54.0824 166.25 52.2252 166.391 52.1353C164.627 49.5186 161.889 49.1639 160.913 49.1214C158.581 48.8843 156.366 50.5253 155.184 50.5267C154.003 50.5282 152.175 49.1696 150.243 49.2091C147.701 49.25 145.362 50.7192 144.055 53.0363C141.423 57.7035 143.396 64.6078 145.973 68.3869C147.232 70.2341 148.734 72.3136 150.702 72.236C152.599 72.1584 153.314 70.9855 155.604 70.9823C157.895 70.9789 158.542 72.2251 160.547 72.1842C162.587 72.1442 163.877 70.2932 165.123 68.436C166.564 66.2865 167.155 64.206 167.19 64.0993C167.146 64.0788 163.211 62.5492 163.164 57.9396Z"
                fill="white"
              />
              <path
                d="M159.401 46.6272C160.446 45.3381 161.15 43.5467 160.957 41.762C159.452 41.8244 157.629 42.7834 156.548 44.0705C155.58 45.2115 154.731 47.0349 154.96 48.7843C156.639 48.9158 158.355 47.9143 159.401 46.6272Z"
                fill="white"
              />
            </g>
            <animateTransform
              xlinkHref="#banner_web_circle_item_3"
              begin="2s"
              dur="0.5s"
              attributeName="transform"
              type="scale"
              values="0; 0.5; 1.04; 1"
              fill="freeze"
            />

            <g
              id="banner_web_circle_item_5"
              transform="scale(0)"
              className="banner_web_circle_item"
            >
              <path
                opacity="0.5"
                d="M598 247C621.196 247 640 228.196 640 205C640 181.804 621.196 163 598 163C574.804 163 556 181.804 556 205C556 228.196 574.804 247 598 247Z"
                fill="url(#paint4_radial_2166_8147)"
              />
              <path
                opacity="0.65"
                d="M598 237C615.673 237 630 222.673 630 205C630 187.327 615.673 173 598 173C580.327 173 566 187.327 566 205C566 222.673 580.327 237 598 237Z"
                fill="url(#paint5_radial_2166_8147)"
              />
              <path
                d="M623.829 205C623.829 219.265 612.265 230.829 598 230.829C583.735 230.829 572.171 219.265 572.171 205C572.171 190.735 583.735 179.171 598 179.171C612.265 179.171 623.829 190.735 623.829 205Z"
                fill="#444052"
                fillOpacity="0.5"
                stroke="#D76FFC"
                strokeWidth="1.1625"
              />
              <g clipPath="url(#filter2_f_2166_8147)">
                <path
                  d="M597.791 189.039C596.473 189.045 595.214 189.158 594.107 189.354C590.845 189.93 590.252 191.137 590.252 193.361V196.3H597.962V197.279H587.359C585.119 197.279 583.156 198.626 582.543 201.188C581.835 204.124 581.804 205.957 582.543 209.023C583.091 211.305 584.4 212.932 586.64 212.932H589.291V209.409C589.291 206.865 591.492 204.62 594.107 204.62H601.807C603.951 204.62 605.662 202.855 605.662 200.703V193.361C605.662 191.272 603.899 189.702 601.807 189.354C600.483 189.133 599.109 189.033 597.791 189.039V189.039ZM593.622 191.402C594.418 191.402 595.068 192.063 595.068 192.876C595.068 193.686 594.418 194.341 593.622 194.341C592.823 194.341 592.175 193.686 592.175 192.876C592.175 192.063 592.823 191.402 593.622 191.402Z"
                  fill="white"
                />
                <path
                  d="M606.623 197.279V200.702C606.623 203.356 604.373 205.59 601.807 205.59H594.107C591.998 205.59 590.252 207.395 590.252 209.508V216.849C590.252 218.938 592.069 220.167 594.107 220.766C596.547 221.484 598.887 221.613 601.807 220.766C603.748 220.204 605.662 219.073 605.662 216.849V213.911H597.962V212.931H609.516C611.757 212.931 612.592 211.368 613.371 209.023C614.176 206.608 614.142 204.285 613.371 201.187C612.817 198.957 611.76 197.279 609.516 197.279H606.623V197.279ZM602.292 215.869C603.091 215.869 603.739 216.524 603.739 217.334C603.739 218.146 603.091 218.807 602.292 218.807C601.496 218.807 600.846 218.146 600.846 217.334C600.846 216.524 601.496 215.869 602.292 215.869Z"
                  fill="white"
                />
              </g>
            </g>
            <animateTransform
              xlinkHref="#banner_web_circle_item_5"
              begin="2s"
              dur="0.5s"
              attributeName="transform"
              type="scale"
              values="0; 0.5; 1.04; 1"
              fill="freeze"
            />

            <g
              id="banner_web_circle_item_2"
              transform="scale(0)"
              className="banner_web_circle_item"
            >
              <path
                opacity="0.65"
                d="M44 305C67.196 305 86 286.196 86 263C86 239.804 67.196 221 44 221C20.804 221 2 239.804 2 263C2 286.196 20.804 305 44 305Z"
                fill="url(#paint6_radial_2166_8147)"
              />
              <path
                opacity="0.65"
                d="M44.0001 295C61.6732 295 76.0001 280.673 76.0001 263C76.0001 245.327 61.6732 231 44.0001 231C26.327 231 12.0001 245.327 12.0001 263C12.0001 280.673 26.327 295 44.0001 295Z"
                fill="url(#paint7_radial_2166_8147)"
              />
              <path
                d="M69.8292 263C69.8292 277.265 58.265 288.829 43.9999 288.829C29.7347 288.829 18.1705 277.265 18.1705 263C18.1705 248.735 29.7347 237.171 43.9999 237.171C58.265 237.171 69.8292 248.735 69.8292 263Z"
                fillOpacity="0.5"
                stroke="#D76FFC"
                strokeWidth="1.1625"
              />
              <g filter="url(#filter3_f_2166_8147)">
                <path
                  d="M55.4133 257.568C54.1414 257.568 53.1123 258.55 53.1123 259.762V267.54C53.1123 268.122 53.3547 268.681 53.7863 269.092C54.2178 269.504 54.8031 269.736 55.4133 269.736C56.0236 269.736 56.6089 269.504 57.0404 269.092C57.4719 268.681 57.7143 268.122 57.7143 267.54V259.762C57.7143 258.55 56.6853 257.568 55.4133 257.568V257.568ZM32.5868 257.568C31.3148 257.568 30.2858 258.55 30.2858 259.762V267.54C30.2858 268.122 30.5282 268.681 30.9597 269.092C31.3912 269.504 31.9765 269.736 32.5868 269.736C33.197 269.736 33.7823 269.504 34.2138 269.092C34.6454 268.681 34.8878 268.122 34.8878 267.54V259.762C34.888 259.474 34.8286 259.188 34.7131 258.922C34.5975 258.655 34.428 258.413 34.2142 258.209C34.0005 258.006 33.7467 257.844 33.4675 257.734C33.1882 257.624 32.8889 257.567 32.5868 257.568V257.568ZM48.5787 251.028L49.9604 248.645C50.0007 248.577 50.0266 248.502 50.0364 248.425C50.0462 248.347 50.0398 248.269 50.0176 248.194C49.9953 248.119 49.9576 248.049 49.9067 247.987C49.8558 247.926 49.7927 247.876 49.7211 247.838C49.6496 247.8 49.5709 247.775 49.4894 247.766C49.408 247.757 49.3254 247.763 49.2466 247.785C49.1677 247.806 49.0942 247.843 49.0302 247.892C48.9662 247.94 48.913 248.001 48.8737 248.07L47.4543 250.508C46.3964 250.104 45.2306 249.876 44.0001 249.876C42.7695 249.876 41.6037 250.103 40.5458 250.506L39.1264 248.071C39.0871 248.003 39.0339 247.942 38.9699 247.893C38.9059 247.844 38.8324 247.808 38.7535 247.786C38.6747 247.765 38.5921 247.758 38.5107 247.768C38.4292 247.777 38.3505 247.801 38.279 247.84C38.2077 247.878 38.145 247.929 38.0943 247.99C38.0437 248.051 38.0062 248.121 37.984 248.196C37.9618 248.271 37.9552 248.349 37.9648 248.427C37.9744 248.504 37.9998 248.579 38.0397 248.647L39.4214 251.03C36.9333 252.383 35.271 254.802 35.271 257.568C35.271 257.587 35.271 257.604 35.2746 257.626C35.271 257.636 35.271 257.648 35.271 257.659V257.661H52.7273V257.568C52.7291 254.802 51.0668 252.384 48.5787 251.028V251.028ZM39.9701 254.407C39.8883 254.406 39.8073 254.39 39.7319 254.36C39.6565 254.33 39.5881 254.285 39.5307 254.23C39.4146 254.117 39.3501 253.966 39.3513 253.808C39.3525 253.65 39.4193 253.499 39.537 253.388C39.6548 253.278 39.8138 253.216 39.9791 253.217C40.1445 253.218 40.3026 253.282 40.4186 253.394C40.5347 253.507 40.5992 253.659 40.598 253.816C40.5968 253.974 40.53 254.125 40.4123 254.236C40.2945 254.346 40.1355 254.408 39.9701 254.407ZM48.03 254.407C47.873 254.396 47.7264 254.328 47.6195 254.218C47.5125 254.108 47.453 253.963 47.453 253.813C47.453 253.663 47.5125 253.518 47.6195 253.408C47.7264 253.298 47.873 253.23 48.03 253.219C48.1951 253.219 48.3534 253.281 48.4701 253.393C48.5869 253.504 48.6524 253.655 48.6524 253.813C48.6524 253.97 48.5869 254.122 48.4701 254.233C48.3534 254.344 48.1951 254.407 48.03 254.407V254.407ZM35.271 270.29C35.271 271.399 36.2155 272.301 37.3831 272.301H38.4373V276.423C38.4373 277.005 38.6798 277.564 39.1113 277.976C39.5428 278.388 40.1281 278.619 40.7383 278.619C41.3486 278.619 41.9339 278.388 42.3654 277.976C42.7969 277.564 43.0393 277.005 43.0393 276.423V272.301H44.9572V276.423C44.9572 277.637 45.9862 278.617 47.2546 278.617C48.5301 278.617 49.5592 277.637 49.5592 276.423V272.301H50.6134C51.7792 272.301 52.7255 271.401 52.7255 270.29V258.114H35.271V270.29Z"
                  fill="white"
                />
              </g>
              <path
                d="M55.4133 257.568C54.1414 257.568 53.1123 258.55 53.1123 259.762V267.54C53.1123 268.122 53.3547 268.681 53.7863 269.093C54.2178 269.504 54.8031 269.736 55.4133 269.736C56.0236 269.736 56.6089 269.504 57.0404 269.093C57.4719 268.681 57.7143 268.122 57.7143 267.54V259.762C57.7143 258.55 56.6853 257.568 55.4133 257.568V257.568ZM32.5868 257.568C31.3148 257.568 30.2858 258.55 30.2858 259.762V267.54C30.2858 268.122 30.5282 268.681 30.9597 269.093C31.3912 269.504 31.9765 269.736 32.5868 269.736C33.197 269.736 33.7823 269.504 34.2138 269.093C34.6454 268.681 34.8878 268.122 34.8878 267.54V259.762C34.888 259.474 34.8286 259.188 34.7131 258.922C34.5975 258.655 34.428 258.413 34.2142 258.209C34.0005 258.006 33.7467 257.844 33.4675 257.734C33.1882 257.624 32.8889 257.567 32.5868 257.568V257.568ZM48.5787 251.028L49.9604 248.645C50.0007 248.577 50.0266 248.502 50.0364 248.425C50.0462 248.347 50.0398 248.269 50.0176 248.194C49.9953 248.119 49.9576 248.049 49.9067 247.988C49.8558 247.927 49.7927 247.876 49.7211 247.838C49.6496 247.8 49.5709 247.775 49.4894 247.766C49.408 247.757 49.3254 247.763 49.2466 247.785C49.1677 247.806 49.0942 247.843 49.0302 247.892C48.9662 247.941 48.913 248.001 48.8737 248.07L47.4543 250.508C46.3964 250.104 45.2306 249.876 44.0001 249.876C42.7695 249.876 41.6037 250.103 40.5458 250.506L39.1264 248.072C39.0871 248.003 39.0339 247.942 38.9699 247.893C38.9059 247.844 38.8324 247.808 38.7535 247.787C38.6747 247.765 38.5921 247.759 38.5107 247.768C38.4292 247.777 38.3505 247.801 38.279 247.84C38.2077 247.878 38.145 247.929 38.0943 247.99C38.0437 248.051 38.0062 248.121 37.984 248.196C37.9618 248.271 37.9552 248.349 37.9648 248.427C37.9744 248.504 37.9998 248.579 38.0397 248.647L39.4214 251.03C36.9333 252.383 35.271 254.802 35.271 257.568C35.271 257.587 35.271 257.604 35.2746 257.626C35.271 257.637 35.271 257.649 35.271 257.659V257.661H52.7273V257.568C52.7291 254.802 51.0668 252.385 48.5787 251.028V251.028ZM39.9701 254.407C39.8883 254.406 39.8073 254.391 39.7319 254.36C39.6565 254.33 39.5881 254.285 39.5307 254.23C39.4146 254.117 39.3501 253.966 39.3513 253.808C39.3525 253.65 39.4193 253.499 39.537 253.388C39.6548 253.278 39.8138 253.216 39.9791 253.217C40.1445 253.218 40.3026 253.282 40.4186 253.395C40.5347 253.507 40.5992 253.659 40.598 253.816C40.5968 253.974 40.53 254.125 40.4123 254.236C40.2945 254.347 40.1355 254.408 39.9701 254.407ZM48.03 254.407C47.873 254.396 47.7264 254.328 47.6195 254.218C47.5125 254.108 47.453 253.963 47.453 253.813C47.453 253.663 47.5125 253.518 47.6195 253.408C47.7264 253.298 47.873 253.23 48.03 253.219C48.1951 253.219 48.3534 253.282 48.4701 253.393C48.5869 253.504 48.6524 253.655 48.6524 253.813C48.6524 253.971 48.5869 254.122 48.4701 254.233C48.3534 254.344 48.1951 254.407 48.03 254.407V254.407ZM35.271 270.29C35.271 271.399 36.2155 272.301 37.3831 272.301H38.4373V276.423C38.4373 277.006 38.6798 277.564 39.1113 277.976C39.5428 278.388 40.1281 278.619 40.7383 278.619C41.3486 278.619 41.9339 278.388 42.3654 277.976C42.7969 277.564 43.0393 277.006 43.0393 276.423V272.301H44.9572V276.423C44.9572 277.637 45.9862 278.617 47.2546 278.617C48.5301 278.617 49.5592 277.637 49.5592 276.423V272.301H50.6134C51.7792 272.301 52.7255 271.401 52.7255 270.29V258.114H35.271V270.29Z"
                fill="white"
              />
            </g>
            <animateTransform
              xlinkHref="#banner_web_circle_item_2"
              begin="2s"
              dur="0.5s"
              attributeName="transform"
              type="scale"
              values="0; 0.5; 1.04; 1"
              fill="freeze"
            />

            <g
              id="banner_web_circle_item_1"
              transform="scale(0)"
              className="banner_web_circle_item"
            >
              <path
                opacity="0.65"
                d="M78 518C101.196 518 120 499.196 120 476C120 452.804 101.196 434 78 434C54.804 434 36 452.804 36 476C36 499.196 54.804 518 78 518Z"
                fill="url(#paint8_radial_2166_8147)"
              />
              <path
                opacity="0.65"
                d="M78.0001 508C95.6732 508 110 493.673 110 476C110 458.327 95.6732 444 78.0001 444C60.327 444 46.0001 458.327 46.0001 476C46.0001 493.673 60.327 508 78.0001 508Z"
                fill="url(#paint9_radial_2166_8147)"
              />
              <path
                d="M103.829 476C103.829 490.265 92.265 501.829 77.9999 501.829C63.7347 501.829 52.1705 490.265 52.1705 476C52.1705 461.735 63.7347 450.171 77.9999 450.171C92.265 450.171 103.829 461.735 103.829 476Z"
                fill="#444052"
                fillOpacity="0.5"
                stroke="#D76FFC"
                strokeWidth="1.1625"
              />
              <path
                d="M75.4803 487.276L87.7959 474.958H78.8409L71.0042 482.797L75.4803 487.276Z"
                fill="white"
              />
              <path
                d="M64.2857 476.079L78.8408 461.524H87.7959L68.7646 480.558L64.2857 476.079Z"
                fill="white"
              />
              <path
                d="M78.8409 490.634H87.796L79.9592 482.797L75.4803 487.276L78.8409 490.634Z"
                fill="white"
              />
              <path
                d="M79.9592 482.797L75.4803 487.276L82.123 484.975L79.9592 482.797Z"
                fill="url(#paint10_linear_2166_8147)"
              />
              <path
                d="M71.0042 482.795L75.4831 478.316L79.962 482.795L75.4831 487.276L71.0042 482.795Z"
                fill="white"
              />
              <g filter="url(#filter4_f_2166_8147)">
                <path
                  d="M87.7959 474.958L79.9592 482.797L87.7959 490.637H78.8408L75.4802 487.276L71.0013 482.797L78.8408 474.958H87.7959ZM78.8408 461.524L64.2857 476.079L68.7646 480.558L87.7959 461.524H78.8408V461.524Z"
                  fill="white"
                />
              </g>
              <path
                d="M87.7959 474.958L79.9592 482.797L87.7959 490.637H78.8408L75.4802 487.276L71.0013 482.797L78.8408 474.958H87.7959ZM78.8408 461.524L64.2857 476.079L68.7646 480.558L87.7959 461.524H78.8408V461.524Z"
                fill="white"
              />
            </g>
            <animateTransform
              xlinkHref="#banner_web_circle_item_1"
              begin="2s"
              dur="0.5s"
              attributeName="transform"
              type="scale"
              values="0; 0.5; 1.04; 1"
              fill="freeze"
            />
            <defs>
              <filter
                id="filter0_f_2166_8147"
                x="432.762"
                y="22.7618"
                width="38.4762"
                height="38.4762"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feGaussianBlur
                  stdDeviation="2"
                  result="effect1_foregroundBlur_2166_8147"
                />
              </filter>
              <filter
                id="filter1_f_2166_8147"
                x="138.81"
                y="37.762"
                width="32.3809"
                height="38.4762"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feGaussianBlur
                  stdDeviation="2"
                  result="effect1_foregroundBlur_2166_8147"
                />
              </filter>
              <filter
                id="filter2_f_2166_8147"
                x="581.81"
                y="185.762"
                width="32.381"
                height="38.4762"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feGaussianBlur
                  stdDeviation="2"
                  result="effect1_foregroundBlur_2166_8147"
                />
              </filter>
              <filter
                id="filter3_f_2166_8147"
                x="28.2858"
                y="245.762"
                width="31.4286"
                height="34.8572"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feGaussianBlur
                  stdDeviation="1"
                  result="effect1_foregroundBlur_2166_8147"
                />
              </filter>
              <filter
                id="filter4_f_2166_8147"
                x="60.2857"
                y="457.524"
                width="31.5102"
                height="37.1132"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feGaussianBlur
                  stdDeviation="2"
                  result="effect1_foregroundBlur_2166_8147"
                />
              </filter>
              <radialGradient
                id="paint0_radial_2166_8147"
                cx="0"
                cy="0"
                r="0.5"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(451.998 41.9983) scale(52.1812)"
              >
                <stop stopColor="#B660E1" />
                <stop offset="0.995" stopColor="#B660E1" stopOpacity="0" />
              </radialGradient>
              <radialGradient
                id="paint1_radial_2166_8147"
                cx="0"
                cy="0"
                r="0.5"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(451.999 41.9987) scale(39.7571)"
              >
                <stop stopColor="#B660E1" />
                <stop offset="0.995" stopColor="#B660E1" stopOpacity="0" />
              </radialGradient>
              <animate
                xlinkHref="#paint0_radial_2166_8147"
                attributeName="r"
                dur="3s"
                begin="1.5s"
                values="0.5; 0.7; 1;"
                fill="freeze"
              />
              <animate
                xlinkHref="#paint1_radial_2166_8147"
                attributeName="r"
                dur="3s"
                begin="1.5s"
                values="0.5; 0.6; 1;"
                fill="freeze"
              />
              <radialGradient
                id="paint2_radial_2166_8147"
                cx="0"
                cy="0"
                r="0.5"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(154.998 56.9983) scale(52.1812)"
              >
                <stop stopColor="#B660E1" />
                <stop offset="0.995" stopColor="#B660E1" stopOpacity="0" />
              </radialGradient>
              <radialGradient
                id="paint3_radial_2166_8147"
                cx="0"
                cy="0"
                r="0.5"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(154.999 56.9987) scale(39.7571)"
              >
                <stop stopColor="#B660E1" />
                <stop offset="0.995" stopColor="#B660E1" stopOpacity="0" />
              </radialGradient>
              <animate
                xlinkHref="#paint2_radial_2166_8147"
                attributeName="r"
                dur="3s"
                begin="1.5s"
                values="0.5; 0.7; 1;"
                fill="freeze"
              />
              <animate
                xlinkHref="#paint3_radial_2166_8147"
                attributeName="r"
                dur="3s"
                begin="1.5s"
                values="0.5; 0.6; 1;"
                fill="freeze"
              />
              <radialGradient
                id="paint4_radial_2166_8147"
                cx="0"
                cy="0"
                r="0.5"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(597.998 204.998) scale(52.1812)"
              >
                <stop stopColor="#B660E1" />
                <stop offset="0.995" stopColor="#B660E1" stopOpacity="0" />
              </radialGradient>
              <radialGradient
                id="paint5_radial_2166_8147"
                cx="0"
                cy="0"
                r="0.5"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(597.999 204.999) scale(39.7571)"
              >
                <stop stopColor="#B660E1" />
                <stop offset="0.995" stopColor="#B660E1" stopOpacity="0" />
              </radialGradient>
              <animate
                xlinkHref="#paint4_radial_2166_8147"
                attributeName="r"
                dur="3s"
                begin="1.5s"
                fill="freeze"
                values="0.5; 0.7; 1;"
              />
              <animate
                xlinkHref="#paint5_radial_2166_8147"
                attributeName="r"
                dur="3s"
                begin="1.5s"
                fill="freeze"
                values="0.5; 0.6; 1;"
              />
              <radialGradient
                id="paint6_radial_2166_8147"
                cx="0"
                cy="0"
                r="0.5"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(43.9983 262.998) scale(52.1812)"
              >
                <stop stopColor="#B660E1" />
                <stop offset="0.995" stopColor="#B660E1" stopOpacity="0" />
              </radialGradient>
              <radialGradient
                id="paint7_radial_2166_8147"
                cx="0"
                cy="0"
                r="0.5"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(43.9988 262.999) scale(39.7571)"
              >
                <stop stopColor="#B660E1" />
                <stop offset="0.995" stopColor="#B660E1" stopOpacity="0" />
              </radialGradient>
              <animate
                xlinkHref="#paint6_radial_2166_8147"
                attributeName="r"
                dur="3s"
                begin="1.5s"
                fill="freeze"
                values="0.5; 0.7; 1;"
              />
              <animate
                xlinkHref="#paint7_radial_2166_8147"
                attributeName="r"
                dur="3s"
                begin="1.5s"
                fill="freeze"
                values="0.5; 0.6; 1;"
              />
              <radialGradient
                id="paint8_radial_2166_8147"
                cx="0"
                cy="0"
                r="0.5"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(77.9983 475.998) scale(52.1812)"
              >
                <stop stopColor="#B660E1" />
                <stop offset="0.995" stopColor="#B660E1" stopOpacity="0" />
              </radialGradient>
              <radialGradient
                id="paint9_radial_2166_8147"
                cx="0"
                cy="0"
                r="0.5"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(77.9988 475.999) scale(39.7571)"
              >
                <stop stopColor="#B660E1" />
                <stop offset="0.995" stopColor="#B660E1" stopOpacity="0" />
              </radialGradient>
              <animate
                xlinkHref="#paint8_radial_2166_8147"
                attributeName="r"
                dur="3s"
                begin="1.5s"
                values="0.5; 0.7; 1;"
                fill="freeze"
              />
              <animate
                xlinkHref="#paint9_radial_2166_8147"
                attributeName="r"
                dur="3s"
                begin="1.5s"
                values="0.5; 0.6; 1;"
                fill="freeze"
              />
              <linearGradient
                id="paint10_linear_2166_8147"
                x1="-638.316"
                y1="146.802"
                x2="-638.187"
                y2="146.673"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#1A237E" stopOpacity="0.4" />
                <stop offset="1" stopColor="#1A237E" stopOpacity="0" />
              </linearGradient>
            </defs>
          </svg>

          <svg
            id="banner-web-mobile"
            width="295"
            height="438"
            viewBox="0 0 295 438"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g>
              <path
                id="banner_web_config"
                opacity="0"
                d="M289.959 144.628C289.959 143.869 289.959 143.131 289.861 142.392L294.255 139.962C293.924 137.876 293.377 135.83 292.622 133.857L287.606 133.955C286.973 132.593 286.218 131.292 285.351 130.066L287.937 125.77C286.612 124.135 285.12 122.643 283.485 121.318L279.189 123.884C277.958 123.031 276.657 122.283 275.3 121.649V116.633C273.335 115.875 271.296 115.328 269.216 115L266.785 119.394C266.047 119.394 265.308 119.394 264.55 119.394C263.792 119.394 263.053 119.394 262.314 119.394L259.942 115C257.863 115.333 255.824 115.88 253.857 116.633V121.649C252.5 122.282 251.199 123.03 249.969 123.884L245.77 121.318C244.129 122.642 242.63 124.134 241.299 125.77L243.884 130.066C243.024 131.293 242.275 132.594 241.649 133.955L236.633 133.857C235.869 135.827 235.322 137.874 235 139.962L239.394 142.392C239.238 143.878 239.238 145.377 239.394 146.863L235 149.313C235.324 151.394 235.871 153.434 236.633 155.398L241.649 155.3C242.271 156.663 243.02 157.965 243.884 159.189L241.299 163.485C242.63 165.121 244.129 166.613 245.77 167.937L250.066 165.371C251.292 166.232 252.593 166.981 253.955 167.606V172.622C255.918 173.384 257.958 173.931 260.04 174.255L262.489 169.861C263.975 170.017 265.474 170.017 266.96 169.861L269.39 174.255C271.473 173.936 273.513 173.388 275.475 172.622V167.606C276.836 166.98 278.137 166.231 279.364 165.371L283.66 167.937C285.295 166.612 286.787 165.12 288.112 163.485L285.526 159.189C286.397 157.965 287.152 156.664 287.781 155.3L292.797 155.398C293.55 153.431 294.097 151.392 294.43 149.313L290.036 146.863C289.92 146.105 289.959 145.386 289.959 144.628ZM264.686 154.62C262.71 154.62 260.778 154.034 259.134 152.936C257.491 151.838 256.21 150.277 255.454 148.451C254.698 146.626 254.5 144.616 254.885 142.678C255.271 140.74 256.223 138.959 257.62 137.562C259.018 136.164 260.798 135.213 262.736 134.827C264.675 134.441 266.684 134.639 268.51 135.396C270.336 136.152 271.896 137.433 272.994 139.076C274.092 140.719 274.678 142.651 274.678 144.628C274.678 145.945 274.418 147.249 273.912 148.465C273.406 149.681 272.665 150.785 271.731 151.714C270.797 152.643 269.688 153.377 268.469 153.876C267.25 154.375 265.945 154.628 264.628 154.62H264.686Z"
                fill="white"
              />
              <animate
                xlinkHref="#banner_web_config"
                attributeName="opacity"
                dur="0.4s"
                fill="freeze"
                values="0; 0; 0; 0.7"
              />
              <animateTransform
                xlinkHref="#banner_web_config"
                attributeName="transform"
                type="scale"
                dur="0.4s"
                from="0"
                to="1"
                fill="freeze"
              />
              <animateTransform
                xlinkHref="#banner_web_config"
                attributeName="transform"
                type="rotate"
                begin="0.4s"
                dur="2s"
                from="360 264.7149658203125 144.62750244140625"
                to="0 264.7149658203125 144.62750244140625"
                repeatCount="indefinite"
              />
            </g>
            <path
              d="M239.24 9.00297H200.84C199.589 9.02997 198.384 9.47497 197.415 10.266C196.447 11.058 195.771 12.151 195.496 13.371L195.24 14.571C194.577 17.549 192.932 20.216 190.57 22.146C188.208 24.076 185.266 25.155 182.216 25.211H145.736C142.843 25.276 140.041 24.194 137.943 22.2C135.844 20.207 134.62 17.464 134.536 14.571V13.371C134.507 12.186 134.008 11.061 133.151 10.242C132.293 9.42298 131.146 8.97797 129.96 9.00297H91.5598C85.2528 9.11597 79.2058 11.535 74.5618 15.804C69.9188 20.073 67.0008 25.896 66.3598 32.171L35.5438 385.035C35.2188 387.986 35.5248 390.972 36.4438 393.794C37.3628 396.617 38.8718 399.211 40.8718 401.405C42.8718 403.598 45.3158 405.34 48.0418 406.515C50.7668 407.691 53.7118 408.271 56.6798 408.219H204.312C210.62 408.103 216.668 405.681 221.311 401.409C225.954 397.137 228.872 391.312 229.512 385.035L260.392 32.171C260.715 29.221 260.406 26.236 259.485 23.414C258.565 20.592 257.053 17.999 255.052 15.807C253.051 13.615 250.606 11.875 247.879 10.701C245.153 9.52797 242.208 8.94897 239.24 9.00297Z"
              fill="white"
              fillOpacity="0.6"
            />
            <path
              d="M200.84 6.50297H200.813L200.787 6.50397C198.978 6.54297 197.234 7.18597 195.833 8.33097C194.432 9.47597 193.455 11.057 193.057 12.822L193.054 12.836L193.051 12.85L192.8 14.028C192.799 14.031 192.798 14.035 192.797 14.039C192.254 16.464 190.913 18.637 188.988 20.21C187.066 21.78 184.673 22.661 182.192 22.711H145.736H145.708L145.68 22.712C143.447 22.762 141.284 21.926 139.665 20.388C138.053 18.857 137.109 16.754 137.036 14.533V13.371V13.341L137.035 13.31C136.989 11.463 136.213 9.70899 134.877 8.43299C133.548 7.16499 131.772 6.47097 129.936 6.50297H91.5598H91.5378L91.5158 6.50397C84.5968 6.62697 77.9638 9.28096 72.8698 13.964C67.7768 18.647 64.5758 25.034 63.8728 31.918L63.8708 31.936L63.8688 31.954L33.0558 384.79C32.6968 388.084 33.0408 391.417 34.0668 394.568C35.0948 397.728 36.7848 400.633 39.0238 403.089C41.2628 405.545 43.9998 407.496 47.0518 408.811C50.0968 410.124 53.3868 410.774 56.7018 410.719H204.312H204.335H204.358C211.277 410.592 217.91 407.934 223.003 403.249C228.096 398.563 231.297 392.174 231.999 385.289L232.001 385.271L232.002 385.253L262.88 32.415C263.237 29.121 262.89 25.789 261.862 22.638C260.831 19.479 259.139 16.576 256.898 14.121C254.658 11.667 251.92 9.71797 248.867 8.40497C245.822 7.09497 242.533 6.44597 239.218 6.50297H200.84Z"
              stroke="white"
              strokeOpacity="0.9"
              strokeWidth="5"
            />
            <path
              d="M198.2 382.379H66.9998C65.3598 382.41 63.7328 382.09 62.2268 381.442C60.7208 380.794 59.3698 379.833 58.2648 378.621C57.1588 377.41 56.3248 375.977 55.8168 374.418C55.3088 372.859 55.1398 371.209 55.3198 369.58C55.6748 366.114 57.2868 362.898 59.8518 360.539C62.4168 358.181 65.7558 356.844 69.2398 356.78H200.44C202.079 356.749 203.706 357.069 205.213 357.717C206.719 358.365 208.07 359.326 209.175 360.538C210.28 361.749 211.114 363.182 211.622 364.741C212.13 366.3 212.3 367.95 212.12 369.58C211.768 373.047 210.157 376.265 207.591 378.624C205.026 380.983 201.684 382.319 198.2 382.379Z"
              fill="white"
              fillOpacity="0.8"
            />
            <path
              d="M208.648 74.9401H88.2798C87.3568 74.9671 86.4398 74.7951 85.5898 74.4351C84.7398 74.0751 83.9778 73.5351 83.3558 72.8521C82.7348 72.1701 82.2677 71.3611 81.9877 70.4811C81.7087 69.6011 81.6228 68.6721 81.7358 67.7561L82.7117 56.5561C82.9147 54.6141 83.8197 52.8131 85.2587 51.4931C86.6967 50.1731 88.5678 49.4241 90.5198 49.3881H210.888C211.807 49.3711 212.719 49.5501 213.563 49.9131C214.407 50.2761 215.165 50.8141 215.785 51.4921C216.406 52.1701 216.875 52.9721 217.161 53.8451C217.448 54.7181 217.546 55.6421 217.448 56.5561L216.456 67.7561C216.257 69.7001 215.353 71.5051 213.914 72.8281C212.476 74.1521 210.602 74.9031 208.648 74.9401Z"
              fill="white"
              fillOpacity="0.8"
            />
            <path
              d="M119.363 114.576H28.9523C28.2593 114.605 27.5693 114.429 26.9313 114.063C26.2933 113.696 25.7202 113.147 25.2532 112.453C24.7862 111.759 24.4362 110.936 24.2262 110.041C24.0162 109.146 23.9512 108.2 24.0362 107.268L24.7702 95.873C24.9222 93.897 25.6022 92.066 26.6822 90.722C27.7632 89.379 29.1682 88.6171 30.6342 88.5801H121.045C121.735 88.5641 122.42 88.746 123.054 89.115C123.688 89.484 124.257 90.0311 124.723 90.7211C125.189 91.4111 125.542 92.227 125.757 93.115C125.972 94.003 126.046 94.943 125.972 95.873L125.227 107.268C125.078 109.246 124.399 111.082 123.318 112.428C122.238 113.775 120.831 114.539 119.363 114.576Z"
              fill="white"
              fillOpacity="0.8"
            />
            <path
              d="M95.3632 156.576H4.95222C4.25922 156.605 3.56923 156.429 2.93123 156.063C2.29323 155.696 1.72022 155.147 1.25322 154.453C0.786219 153.759 0.436241 152.936 0.226241 152.041C0.0162415 151.146 -0.0487609 150.2 0.0362391 149.268L0.770217 137.873C0.922217 135.897 1.60224 134.066 2.68224 132.722C3.76324 131.379 5.16823 130.617 6.63423 130.58H97.0452C97.7352 130.564 98.4202 130.746 99.0542 131.115C99.6882 131.484 100.257 132.031 100.723 132.721C101.189 133.411 101.542 134.227 101.757 135.115C101.972 136.003 102.046 136.943 101.972 137.873L101.227 149.268C101.078 151.246 100.399 153.082 99.3182 154.428C98.2382 155.775 96.8312 156.539 95.3632 156.576Z"
              fill="white"
              fillOpacity="0.8"
            />
            <path
              d="M233.128 56.1709C233.074 56.7139 232.822 57.2169 232.421 57.5849C232.02 57.9539 231.497 58.1619 230.952 58.1709C230.697 58.1749 230.443 58.1249 230.208 58.0229C229.973 57.9209 229.763 57.7709 229.59 57.5819C229.418 57.3929 229.288 57.1689 229.208 56.9259C229.128 56.6829 229.101 56.4259 229.128 56.1709C229.183 55.6309 229.436 55.1299 229.837 54.7639C230.239 54.3979 230.761 54.1929 231.304 54.1879C231.559 54.1809 231.813 54.2299 232.048 54.3299C232.283 54.4299 232.493 54.5779 232.666 54.7659C232.839 54.9539 232.969 55.1769 233.049 55.4189C233.129 55.6609 233.156 55.9179 233.128 56.1709Z"
              fill="white"
            />
            <path
              d="M232.6 62.1549C232.549 62.6959 232.3 63.1989 231.902 63.5679C231.503 63.9369 230.983 64.1459 230.44 64.1549C230.184 64.1589 229.93 64.1089 229.695 64.0069C229.461 63.9049 229.25 63.7549 229.078 63.5659C228.905 63.3769 228.775 63.1529 228.695 62.9099C228.616 62.6669 228.589 62.4099 228.616 62.1549C228.667 61.6149 228.915 61.1119 229.314 60.7429C229.712 60.3739 230.233 60.1649 230.776 60.1549C231.032 60.1519 231.285 60.2019 231.52 60.3039C231.755 60.4059 231.965 60.5559 232.138 60.7449C232.31 60.9339 232.441 61.1569 232.52 61.4009C232.6 61.6439 232.627 61.9009 232.6 62.1549Z"
              fill="white"
            />
            <path
              d="M232.088 68.1229C232.034 68.6659 231.782 69.1689 231.381 69.5369C230.98 69.9059 230.457 70.1149 229.912 70.1229C229.657 70.1269 229.403 70.0769 229.168 69.9749C228.933 69.8729 228.723 69.7229 228.55 69.5339C228.378 69.3449 228.248 69.1209 228.168 68.8779C228.088 68.6349 228.061 68.3779 228.088 68.1229C228.143 67.5809 228.395 67.078 228.796 66.71C229.197 66.341 229.72 66.1319 230.264 66.1229C230.52 66.1199 230.774 66.1699 231.009 66.2719C231.244 66.3739 231.454 66.524 231.627 66.713C231.799 66.902 231.929 67.126 232.009 67.369C232.088 67.612 232.116 67.8689 232.088 68.1229Z"
              fill="white"
            />
            <path
              d="M214.536 282.667H68.0879C67.4279 282.681 66.7719 282.553 66.1649 282.292C65.5579 282.032 65.0139 281.645 64.5689 281.157C64.1239 280.669 63.7879 280.092 63.5829 279.464C63.3789 278.836 63.3109 278.172 63.3839 277.515L70.1999 200.475C70.3409 199.08 70.9889 197.785 72.0209 196.835C73.0529 195.886 74.3979 195.348 75.7999 195.323H222.2C222.859 195.313 223.513 195.442 224.117 195.704C224.722 195.965 225.265 196.353 225.708 196.84C226.152 197.327 226.486 197.904 226.69 198.531C226.893 199.157 226.961 199.82 226.888 200.475L220.152 277.515C220.011 278.914 219.361 280.211 218.325 281.161C217.29 282.111 215.941 282.647 214.536 282.667Z"
              fill="white"
              fillOpacity="0.8"
            />
            <path
              d="M77.5781 201.951L211.423 277.049"
              stroke="white"
              strokeWidth="2"
            />
            <path d="M219 202L69 277" stroke="white" strokeWidth="2" />
            <path
              d="M108.376 298.763H62.776C62.616 298.767 62.4579 298.736 62.3109 298.673C62.1639 298.61 62.032 298.516 61.925 298.398C61.817 298.279 61.736 298.139 61.687 297.987C61.638 297.835 61.622 297.674 61.64 297.515C61.672 297.174 61.8279 296.857 62.0789 296.624C62.3299 296.39 62.658 296.258 63 296.252H108.6C108.762 296.248 108.922 296.279 109.07 296.343C109.218 296.407 109.351 296.503 109.459 296.623C109.566 296.743 109.647 296.885 109.695 297.039C109.743 297.193 109.757 297.355 109.736 297.515C109.701 297.854 109.543 298.167 109.293 298.397C109.042 298.627 108.716 298.757 108.376 298.763Z"
              fill="white"
              fillOpacity="0.8"
            />
            <path
              d="M165.368 298.763H116.424C116.263 298.769 116.102 298.74 115.954 298.678C115.805 298.616 115.671 298.522 115.562 298.404C115.452 298.285 115.37 298.145 115.32 297.991C115.27 297.838 115.254 297.676 115.272 297.515C115.304 297.174 115.46 296.857 115.711 296.624C115.961 296.39 116.29 296.258 116.632 296.252H165.592C165.753 296.248 165.914 296.279 166.062 296.343C166.21 296.407 166.343 296.503 166.45 296.623C166.558 296.743 166.639 296.885 166.687 297.039C166.735 297.193 166.749 297.355 166.728 297.515C166.693 297.854 166.535 298.167 166.285 298.397C166.034 298.627 165.708 298.757 165.368 298.763Z"
              fill="white"
              fillOpacity="0.8"
            />
            <path
              d="M92.5998 309.883H61.8158C61.6538 309.887 61.4928 309.855 61.3438 309.792C61.1948 309.728 61.0618 309.633 60.9528 309.513C60.8438 309.393 60.7608 309.252 60.7108 309.098C60.6618 308.943 60.6448 308.78 60.6638 308.619C60.6978 308.28 60.8549 307.964 61.1059 307.732C61.3559 307.499 61.6818 307.365 62.0238 307.355H92.8719C93.0329 307.355 93.1919 307.388 93.3399 307.453C93.4869 307.517 93.6199 307.612 93.7279 307.732C93.8369 307.851 93.9188 307.991 93.9698 308.144C94.0208 308.297 94.0388 308.459 94.0238 308.619C93.9878 308.97 93.8208 309.295 93.5578 309.529C93.2938 309.763 92.9518 309.889 92.5998 309.883Z"
              fill="white"
              fillOpacity="0.8"
            />
            <path
              d="M151.224 309.883H100.696C100.534 309.887 100.374 309.855 100.225 309.792C100.076 309.728 99.9432 309.633 99.8342 309.513C99.7242 309.393 99.6422 309.252 99.5922 309.098C99.5422 308.943 99.5263 308.78 99.5443 308.619C99.5803 308.277 99.7392 307.959 99.9932 307.726C100.246 307.493 100.576 307.361 100.92 307.355H151.432C151.594 307.352 151.755 307.383 151.904 307.447C152.053 307.511 152.186 307.606 152.295 307.726C152.404 307.846 152.487 307.987 152.536 308.141C152.586 308.296 152.603 308.459 152.584 308.619C152.553 308.961 152.397 309.278 152.146 309.511C151.895 309.745 151.567 309.877 151.224 309.883Z"
              fill="white"
              fillOpacity="0.8"
            />
            <path
              d="M143.064 320.987H60.8398C60.6788 320.993 60.5178 320.964 60.3698 320.902C60.2208 320.84 60.0868 320.746 59.9778 320.628C59.8678 320.509 59.7858 320.369 59.7358 320.215C59.6858 320.062 59.6698 319.9 59.6878 319.739C59.7228 319.397 59.8828 319.079 60.1358 318.846C60.3898 318.613 60.7198 318.481 61.0638 318.475H143.288C143.449 318.475 143.609 318.508 143.756 318.572C143.904 318.637 144.036 318.732 144.145 318.851C144.254 318.97 144.336 319.111 144.387 319.264C144.438 319.417 144.456 319.579 144.44 319.739C144.401 320.079 144.24 320.393 143.987 320.623C143.734 320.852 143.406 320.982 143.064 320.987Z"
              fill="white"
              fillOpacity="0.8"
            />
            <path
              d="M156.6 320.987H151.176C151.015 320.993 150.854 320.964 150.706 320.902C150.557 320.84 150.423 320.746 150.314 320.628C150.204 320.509 150.122 320.369 150.072 320.215C150.022 320.062 150.005 319.9 150.024 319.739C150.055 319.398 150.212 319.081 150.462 318.847C150.713 318.614 151.042 318.482 151.384 318.475H156.824C156.985 318.472 157.146 318.503 157.294 318.567C157.442 318.631 157.575 318.726 157.682 318.846C157.79 318.966 157.871 319.108 157.919 319.263C157.967 319.417 157.981 319.579 157.96 319.739C157.925 320.078 157.767 320.391 157.517 320.621C157.266 320.851 156.94 320.981 156.6 320.987Z"
              fill="white"
              fillOpacity="0.8"
            />
            <path
              d="M98.2481 332.107H59.8481C59.6871 332.108 59.5271 332.075 59.3801 332.01C59.2321 331.946 59.1001 331.851 58.9911 331.731C58.8821 331.612 58.8001 331.472 58.7491 331.319C58.6981 331.166 58.6801 331.004 58.6961 330.843C58.7311 330.501 58.8901 330.183 59.1441 329.95C59.3981 329.717 59.7281 329.585 60.0721 329.579H98.4721C98.6341 329.576 98.7951 329.607 98.9431 329.671C99.0921 329.735 99.2261 329.83 99.3351 329.95C99.4441 330.07 99.5261 330.211 99.5761 330.365C99.6261 330.519 99.6421 330.682 99.6241 330.843C99.5891 331.186 99.4291 331.504 99.1761 331.736C98.9221 331.969 98.5921 332.101 98.2481 332.107Z"
              fill="white"
              fillOpacity="0.8"
            />
            <path
              d="M154.104 332.107H106.296C106.135 332.108 105.975 332.075 105.828 332.01C105.68 331.946 105.548 331.851 105.439 331.731C105.331 331.612 105.248 331.472 105.197 331.319C105.147 331.166 105.128 331.004 105.144 330.843C105.179 330.501 105.339 330.183 105.592 329.95C105.846 329.717 106.176 329.585 106.52 329.579H154.312C154.474 329.576 154.635 329.607 154.784 329.671C154.932 329.735 155.066 329.83 155.175 329.95C155.284 330.07 155.366 330.211 155.416 330.365C155.466 330.519 155.482 330.682 155.464 330.843C155.429 331.183 155.272 331.499 155.022 331.731C154.772 331.964 154.446 332.097 154.104 332.107Z"
              fill="white"
              fillOpacity="0.8"
            />
            <path
              d="M106.168 343.211H58.8876C58.7256 343.215 58.5657 343.184 58.4177 343.12C58.2697 343.056 58.1366 342.96 58.0286 342.84C57.9206 342.72 57.8407 342.578 57.7927 342.424C57.7447 342.27 57.7307 342.107 57.7517 341.947C57.7867 341.609 57.9437 341.295 58.1947 341.066C58.4447 340.836 58.7716 340.705 59.1116 340.699H106.376C106.537 340.694 106.697 340.723 106.846 340.785C106.995 340.847 107.129 340.941 107.238 341.059C107.347 341.178 107.43 341.318 107.48 341.472C107.53 341.625 107.546 341.787 107.528 341.947C107.496 342.288 107.34 342.606 107.089 342.839C106.838 343.072 106.51 343.205 106.168 343.211Z"
              fill="white"
              fillOpacity="0.8"
            />
            <path
              d="M152.28 343.211H114.2C114.039 343.215 113.878 343.184 113.73 343.12C113.582 343.056 113.45 342.96 113.342 342.84C113.234 342.72 113.153 342.578 113.105 342.424C113.057 342.27 113.043 342.107 113.064 341.947C113.099 341.609 113.257 341.295 113.507 341.066C113.758 340.836 114.084 340.705 114.424 340.699H152.504C152.665 340.694 152.826 340.723 152.975 340.785C153.123 340.847 153.257 340.941 153.366 341.059C153.476 341.178 153.558 341.318 153.608 341.472C153.658 341.625 153.675 341.787 153.656 341.947C153.621 342.29 153.461 342.608 153.208 342.84C152.954 343.073 152.624 343.205 152.28 343.211Z"
              fill="white"
              fillOpacity="0.8"
            />
            <g id="banner_web_icon_text" transform="scale(0)">
              <path
                d="M246.2 48.8161V57.2001L238.2 61.4081C237.889 61.5751 237.629 61.823 237.448 62.126C237.267 62.429 237.171 62.7751 237.171 63.1281C237.171 63.4811 237.267 63.8271 237.448 64.1301C237.629 64.4331 237.889 64.6811 238.2 64.8481L246.2 69.0561V77.4401C246.2 78.3351 246.556 79.1941 247.189 79.8271C247.822 80.4601 248.681 80.816 249.576 80.816H278.2C279.097 80.816 279.957 80.4611 280.593 79.8281C281.228 79.1961 281.588 78.3371 281.592 77.4401V48.8161C281.592 47.9161 281.235 47.0541 280.598 46.4181C279.962 45.7811 279.1 45.4241 278.2 45.4241H249.528C248.638 45.4371 247.789 45.8001 247.166 46.4351C246.543 47.0711 246.196 47.9261 246.2 48.8161Z"
                fill="#D76FFC"
              />
              <g opacity="0.9">
                <path
                  opacity="0.9"
                  d="M255.992 57.552H272.264C272.795 57.552 273.303 57.341 273.678 56.966C274.054 56.591 274.264 56.082 274.264 55.552C274.264 55.022 274.054 54.513 273.678 54.138C273.303 53.763 272.795 53.552 272.264 53.552H255.992C255.462 53.552 254.953 53.763 254.578 54.138C254.203 54.513 253.992 55.022 253.992 55.552C253.992 56.082 254.203 56.591 254.578 56.966C254.953 57.341 255.462 57.552 255.992 57.552Z"
                  fill="white"
                />
                <path
                  opacity="0.9"
                  d="M272.264 61.2H255.992C255.462 61.2 254.953 61.411 254.578 61.786C254.203 62.161 253.992 62.67 253.992 63.2C253.992 63.73 254.203 64.239 254.578 64.614C254.953 64.989 255.462 65.2 255.992 65.2H272.264C272.795 65.2 273.303 64.989 273.678 64.614C274.054 64.239 274.264 63.73 274.264 63.2C274.264 62.67 274.054 62.161 273.678 61.786C273.303 61.411 272.795 61.2 272.264 61.2Z"
                  fill="white"
                />
                <path
                  opacity="0.9"
                  d="M272.264 68.704H255.992C255.462 68.704 254.953 68.915 254.578 69.29C254.203 69.665 253.992 70.174 253.992 70.704C253.992 71.235 254.203 71.743 254.578 72.118C254.953 72.493 255.462 72.704 255.992 72.704H272.264C272.795 72.704 273.303 72.493 273.678 72.118C274.054 71.743 274.264 71.235 274.264 70.704C274.264 70.174 274.054 69.665 273.678 69.29C273.303 68.915 272.795 68.704 272.264 68.704Z"
                  fill="white"
                />
              </g>
              <animateTransform
                xlinkHref="#banner_web_icon_text"
                attributeName="transform"
                type="scale"
                begin="1.2s"
                dur="0.5s"
                values="0; 1.1; 1"
                fill="freeze"
              />
            </g>

            <g id="banner_web_icon_home" transform="scale(0)">
              <path
                d="M84.928 35.328H91.76L95.2801 42C95.5121 42.435 95.858 42.799 96.281 43.052C96.703 43.306 97.187 43.44 97.68 43.44C98.173 43.44 98.657 43.306 99.079 43.052C99.502 42.799 99.848 42.435 100.08 42L103.6 35.328H110.432C111.081 35.328 111.723 35.2 112.322 34.951C112.921 34.703 113.465 34.338 113.922 33.879C114.38 33.42 114.743 32.875 114.99 32.275C115.236 31.675 115.362 31.033 115.36 30.384V4.92803C115.36 3.62103 114.841 2.36802 113.917 1.44302C112.992 0.519017 111.739 2.34404e-05 110.432 2.34404e-05H84.928C84.28 -0.00197656 83.638 0.124026 83.04 0.371026C82.441 0.618026 81.897 0.981019 81.439 1.43902C80.981 1.89702 80.618 2.44103 80.371 3.04003C80.124 3.63903 79.998 4.28003 80 4.92803V30.528C80.033 31.813 80.567 33.034 81.488 33.93C82.408 34.827 83.643 35.328 84.928 35.328Z"
                fill="#FBC02C"
              />
              <path
                opacity="0.9"
                d="M97.6962 7.63208L89.8242 12.2401V25.7121H95.6802V16.6721H99.7283V25.7121H105.584V12.2401L97.6962 7.63208Z"
                fill="white"
              />
              <animateTransform
                xlinkHref="#banner_web_icon_home"
                attributeName="transform"
                begin="0.7s"
                type="scale"
                dur="0.5s"
                values="0; 1.1; 1"
                fill="freeze"
              />
            </g>

            <g id="banner_web_icon_search" transform="scale(0)">
              <path
                d="M161.08 401.664H155L151.08 394.208C150.885 393.847 150.597 393.545 150.244 393.335C149.892 393.125 149.49 393.014 149.08 393.014C148.67 393.014 148.267 393.125 147.915 393.335C147.563 393.545 147.274 393.847 147.08 394.208L143.16 401.664H136.92C135.43 401.664 134.002 402.256 132.949 403.309C131.895 404.362 131.304 405.79 131.304 407.28V431.44C131.304 432.929 131.895 434.358 132.949 435.411C134.002 436.464 135.43 437.056 136.92 437.056H161.08C162.569 437.056 163.998 436.464 165.051 435.411C166.104 434.358 166.696 432.929 166.696 431.44V407.28C166.696 405.79 166.104 404.362 165.051 403.309C163.998 402.256 162.569 401.664 161.08 401.664Z"
                fill="#D76FFC"
              />
              <path
                opacity="0.9"
                d="M152.425 410.896C151.251 409.722 149.768 408.907 148.148 408.545C146.528 408.184 144.839 408.291 143.278 408.855C141.717 409.419 140.349 410.416 139.334 411.729C138.319 413.043 137.699 414.618 137.547 416.27C137.394 417.923 137.716 419.585 138.474 421.062C139.232 422.538 140.395 423.768 141.827 424.608C143.259 425.447 144.9 425.862 146.559 425.802C148.217 425.743 149.825 425.212 151.193 424.272C151.259 424.669 151.443 425.037 151.721 425.328L157.161 430.752C157.528 431.119 158.026 431.325 158.545 431.325C159.064 431.325 159.562 431.119 159.929 430.752C160.296 430.385 160.502 429.887 160.502 429.368C160.502 428.849 160.296 428.351 159.929 427.984L154.505 422.56C154.213 422.271 153.838 422.081 153.433 422.016C154.583 420.334 155.112 418.304 154.928 416.275C154.744 414.246 153.859 412.344 152.425 410.896ZM150.569 421.408C149.711 422.264 148.619 422.847 147.431 423.083C146.242 423.319 145.011 423.197 143.891 422.733C142.772 422.269 141.816 421.483 141.143 420.476C140.47 419.468 140.11 418.284 140.11 417.072C140.11 415.86 140.47 414.676 141.143 413.668C141.816 412.661 142.772 411.875 143.891 411.411C145.011 410.947 146.242 410.825 147.431 411.061C148.619 411.297 149.711 411.88 150.569 412.736C151.139 413.305 151.591 413.981 151.899 414.725C152.208 415.469 152.366 416.267 152.366 417.072C152.366 417.878 152.208 418.675 151.899 419.419C151.591 420.163 151.139 420.839 150.569 421.408Z"
                fill="white"
              />
              <animateTransform
                xlinkHref="#banner_web_icon_search"
                attributeName="transform"
                begin="1.5s"
                type="scale"
                dur="0.5s"
                values="0; 1.1; 1"
                fill="freeze"
              />
            </g>

            <path
              d="M218.131 167.809H139.731C139.071 167.82 138.417 167.69 137.811 167.428C137.206 167.167 136.662 166.78 136.218 166.293C135.773 165.806 135.437 165.23 135.231 164.603C135.026 163.976 134.956 163.313 135.027 162.657L140.931 95.1529C141.071 93.7579 141.719 92.4619 142.751 91.5129C143.784 90.5629 145.128 90.0249 146.531 90.0009H224.931C225.591 89.9879 226.246 90.1159 226.853 90.3759C227.46 90.6369 228.004 91.0239 228.45 91.5109C228.895 91.9989 229.231 92.5759 229.435 93.2039C229.64 93.8319 229.708 94.4969 229.635 95.1529L223.731 162.657C223.586 164.051 222.937 165.344 221.906 166.293C220.875 167.242 219.532 167.781 218.131 167.809Z"
              fill="white"
              fillOpacity="0.8"
            />
            <path
              d="M218.131 169.309H218.145H218.16C219.927 169.274 221.621 168.594 222.922 167.397C224.222 166.2 225.041 164.569 225.223 162.811L225.224 162.799L225.225 162.788L231.127 95.2999C231.221 94.4379 231.13 93.5649 230.862 92.7399C230.591 91.9089 230.147 91.1449 229.557 90.4999C228.968 89.8549 228.248 89.3419 227.445 88.9979C226.647 88.6549 225.785 88.4859 224.917 88.5009H146.531H146.518H146.505C144.735 88.5319 143.038 89.2109 141.736 90.4089C140.433 91.6069 139.616 93.241 139.438 95.002L139.437 95.012L139.436 95.0219L133.533 162.513C133.443 163.375 133.536 164.246 133.806 165.07C134.077 165.899 134.522 166.66 135.11 167.304C135.698 167.948 136.416 168.46 137.217 168.806C138.014 169.15 138.874 169.321 139.742 169.309H218.131Z"
              stroke="white"
              strokeOpacity="0.3"
              strokeWidth="3"
            />
            <path d="M199.5 130L222 168H177L199.5 130Z" fill="#D0CFD4" />
            <path d="M163.5 122L191 168H136L163.5 122Z" fill="white" />
            <path
              d="M181 122C185.418 122 189 118.418 189 114C189 109.582 185.418 106 181 106C176.582 106 173 109.582 173 114C173 118.418 176.582 122 181 122Z"
              fill="white"
            />
          </svg>
        </>
      )}
      {[1, 2, 3].includes(step) && (
        <svg
          id="banner-web-man"
          width="266"
          height="334"
          viewBox="0 0 266 334"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M213.464 105.768C213.464 105.768 200.424 138.088 187.656 141.576C174.888 145.064 155.656 142.232 155.656 142.232L149.704 143.832L143.864 142.968H143.656L137.08 142.808C136.843 142.828 136.605 142.779 136.395 142.668C136.184 142.557 136.01 142.388 135.892 142.182C135.774 141.975 135.718 141.738 135.73 141.501C135.742 141.263 135.822 141.034 135.96 140.84L138.312 137.64C138.51 137.377 138.784 137.182 139.096 137.08L145.368 135.064C145.616 135.009 145.873 135.009 146.12 135.064L155.72 136.584C155.72 136.584 182.36 132.216 185.08 129.752C187.8 127.288 195.816 101.448 195.816 101.448L213.464 105.768Z"
            fill="#EEC1BB"
          />
          <path
            opacity="0.1"
            d="M156.312 136.376L155.688 136.472L146.088 134.952C145.84 134.897 145.584 134.897 145.336 134.952L139.064 136.968C138.751 137.07 138.478 137.265 138.28 137.528L135.928 140.728C135.79 140.922 135.71 141.151 135.698 141.389C135.686 141.626 135.742 141.863 135.86 142.069C135.977 142.276 136.152 142.445 136.362 142.556C136.573 142.667 136.811 142.716 137.048 142.696L143.624 142.856H143.832L147.752 143.432C151.096 141.747 154.02 139.336 156.312 136.376Z"
            fill="black"
          />
          <path
            d="M221.336 73.752C211.864 70.648 198.536 77.768 193.432 107.592L213.096 113.4C213.096 113.4 234.872 78.2 221.336 73.752Z"
            fill="#A336D9"
          />
          <path
            d="M166.232 34.776C166.232 35.768 166.76 36.552 167.4 36.552C168.04 36.552 168.6 35.704 168.552 34.744C168.504 33.784 168.024 32.984 167.384 33C166.744 33.016 166.232 33.8 166.232 34.776Z"
            fill="#263238"
          />
          <path
            d="M170.104 35.752L165.448 43.4479C165.448 43.4479 167.048 45.2719 170.552 43.9279L170.104 35.752Z"
            fill="#EEC1BB"
          />
          <path
            d="M170.984 28.6C170.927 28.6646 170.855 28.7133 170.773 28.7414C170.692 28.7694 170.605 28.7759 170.52 28.76C169.89 28.652 169.244 28.6958 168.635 28.8878C168.025 29.0798 167.47 29.4145 167.016 29.864C166.918 29.9551 166.79 30.0057 166.656 30.0057C166.523 30.0057 166.394 29.9551 166.296 29.864C166.204 29.7636 166.153 29.6323 166.153 29.496C166.153 29.3597 166.204 29.2284 166.296 29.128C166.861 28.5497 167.559 28.1179 168.328 27.8698C169.097 27.6216 169.916 27.5648 170.712 27.704C170.78 27.7119 170.845 27.7331 170.904 27.7665C170.963 27.7998 171.015 27.8446 171.057 27.8982C171.098 27.9518 171.129 28.0132 171.147 28.0787C171.165 28.1442 171.169 28.2127 171.16 28.28C171.136 28.4022 171.074 28.5139 170.984 28.6Z"
            fill="#263238"
          />
          <path
            d="M203.88 27.8C204.6 40.808 205.192 46.312 199.448 53.704C190.28 61.624 174.664 62.888 170.056 50.36C165.912 39.16 165.432 19.752 177.464 13.048C179.505 11.9108 181.75 11.187 184.071 10.9182C186.392 10.6493 188.743 10.8405 190.99 11.481C193.237 12.1215 195.335 13.1986 197.166 14.6508C198.996 16.1029 200.522 17.9016 201.656 19.944C202.988 22.3586 203.748 25.0459 203.88 27.8Z"
            fill="#EEC1BB"
          />
          <path
            d="M185.752 56.2638L189.048 75.5439L205.112 71.8319L199.496 52.1519L185.752 56.2638Z"
            fill="#EEC1BB"
          />
          <path
            d="M174.184 28.7599C175 20.3119 172.088 30.0719 168.184 18.9199C164.28 7.76788 182.728 -1.28813 185.672 0.791872C188.616 2.87187 186.936 6.05587 196.696 7.86387C199.359 8.28672 201.776 9.66519 203.496 11.7413C205.216 13.8175 206.12 16.4491 206.04 19.1439C206.04 19.1439 211.656 21.7359 209.656 33.7999C208.188 41.5298 204.897 48.7978 200.056 54.9999C200.056 54.9999 196.36 51.1919 190.456 54.6959C188.152 53.192 186.203 51.2047 184.744 48.8719C182.12 44.9359 181.304 41.1919 177.704 40.8719C170.184 40.1839 173.912 31.5439 174.184 28.7599Z"
            fill="#444052"
          />
          <path
            d="M205 20.5998C205 20.5998 213 15.7038 209.448 10.5678C205.896 5.43179 207.608 16.2318 205 20.5998Z"
            fill="#263238"
          />
          <path
            d="M176.472 33.6719C174.698 35.6556 173.783 38.2623 173.928 40.9199C174.152 44.4399 177.608 45.0639 180.328 43.1439C183.048 41.2239 185.624 37.4799 184.056 34.3919C183.708 33.7181 183.197 33.1425 182.569 32.7179C181.94 32.2932 181.216 32.0331 180.461 31.9614C179.706 31.8898 178.945 32.0088 178.248 32.3077C177.551 32.6065 176.941 33.0756 176.472 33.6719Z"
            fill="#FFC3BD"
          />
          <path
            opacity="0.1"
            d="M186.056 58.0878L187.368 65.7358C187.253 63.8419 187.513 61.944 188.134 60.151C188.754 58.358 189.723 56.7052 190.984 55.2878C190.004 55.3507 189.052 55.6354 188.198 56.1205C187.344 56.6055 186.612 57.2782 186.056 58.0878Z"
            fill="black"
          />
          <path
            d="M73.112 107.816H68.52V134.904H73.112V107.816Z"
            fill="#A336D9"
          />
          <path
            opacity="0.7"
            d="M73.112 107.816H68.52V134.904H73.112V107.816Z"
            fill="white"
          />
          <path
            d="M41.5604 54.0239H30.1204C28.0623 54.0239 26.0885 54.8415 24.6332 56.2968C23.1779 57.7521 22.3604 59.7259 22.3604 61.7839V114.792C22.3604 115.811 22.561 116.82 22.951 117.762C23.341 118.703 23.9126 119.559 24.6332 120.279C25.3538 121 26.2092 121.571 27.1507 121.961C28.0922 122.351 29.1013 122.552 30.1204 122.552H41.5604V54.0239Z"
            fill="#D0CFD4"
          />
          <path
            d="M111.528 54.0239H34.1204C29.8346 54.0239 26.3604 57.4982 26.3604 61.7839V114.776C26.3604 119.062 29.8346 122.536 34.1204 122.536H111.528C115.814 122.536 119.288 119.062 119.288 114.776V61.7839C119.288 57.4982 115.814 54.0239 111.528 54.0239Z"
            fill="white"
          />
          <path
            opacity="0.5"
            d="M111.528 54.0239H34.1204C29.8346 54.0239 26.3604 57.4982 26.3604 61.7839V114.776C26.3604 119.062 29.8346 122.536 34.1204 122.536H111.528C115.814 122.536 119.288 119.062 119.288 114.776V61.7839C119.288 57.4982 115.814 54.0239 111.528 54.0239Z"
            fill="white"
          />
          <path
            d="M111.528 57.2239H34.1201C31.6016 57.2239 29.5601 59.2655 29.5601 61.7839V114.776C29.5601 117.294 31.6016 119.336 34.1201 119.336H111.528C114.046 119.336 116.088 117.294 116.088 114.776V61.7839C116.088 59.2655 114.046 57.2239 111.528 57.2239Z"
            fill="#444052"
          />
          <path
            d="M54.104 146.264C54.2384 141.921 56.058 137.801 59.1774 134.777C62.2969 131.752 66.4711 130.061 70.816 130.061C75.1609 130.061 79.3351 131.752 82.4545 134.777C85.574 137.801 87.3936 141.921 87.528 146.264H54.104Z"
            fill="#A336D9"
          />
          <path
            d="M93.5441 140.568H60.1201V145.992H126.968V143.768L93.5441 140.568Z"
            fill="#A336D9"
          />
          <path
            opacity="0.8"
            d="M93.5441 140.568H60.1201V145.992H126.968V143.768L93.5441 140.568Z"
            fill="white"
          />
          <path
            d="M93.5441 145.992H60.1201V140.568L93.5441 143.768V145.992Z"
            fill="#A336D9"
          />
          <path
            opacity="0.6"
            d="M93.5441 145.992H60.1201V140.568L93.5441 143.768V145.992Z"
            fill="white"
          />
          <path
            d="M98.0242 145.992H0.120117V154.2H98.0242V145.992Z"
            fill="#D0CFD4"
          />
          <path
            d="M177.048 145.992H93.5439V154.2H177.048V145.992Z"
            fill="#A19FA9"
          />
          <path
            d="M147.768 274.568L152.392 321.32H141.32L130.232 275.784L147.768 274.568Z"
            fill="#EEC1BB"
          />
          <path
            d="M140.28 318.2L154.408 318.44C154.666 318.446 154.914 318.539 155.112 318.705C155.31 318.871 155.445 319.099 155.496 319.352L157.864 330.888C157.964 331.378 157.867 331.887 157.595 332.306C157.322 332.725 156.896 333.02 156.408 333.128H156.008C150.904 332.952 146.408 332.6 140.008 332.488C132.536 332.36 134.408 333.288 125.608 333.272C120.312 333.272 119.448 327.208 121.688 326.952C132.008 325.832 133.128 322.744 137.16 319.128C138.051 318.447 139.161 318.116 140.28 318.2Z"
            fill="#151027"
          />
          <path
            opacity="0.1"
            d="M151.192 309.112L147.768 274.568L130.232 275.784L138.344 309.112H151.192Z"
            fill="black"
          />
          <path
            d="M223.576 166.776L178.168 168.376C178.168 168.376 117 189.768 115.4 206.2C113.64 223.128 134.184 300.904 134.184 300.904H152.44C152.44 300.904 147.4 243.832 145.48 226.36C143.56 208.888 209.144 214.664 220.536 199.768C230.952 186.104 223.576 166.776 223.576 166.776Z"
            fill="#263238"
          />
          <path
            opacity="0.2"
            d="M223.576 166.776L178.168 168.376C178.168 168.376 117 189.768 115.4 206.2C113.64 223.128 134.184 300.904 134.184 300.904H152.44C152.44 300.904 147.4 243.832 145.48 226.36C143.56 208.888 209.144 214.664 220.536 199.768C230.952 186.104 223.576 166.776 223.576 166.776Z"
            fill="#444052"
          />
          <path
            d="M155.48 298.344L155.88 304.792H133.32L131.112 298.344H155.48Z"
            fill="#FBC02C"
          />
          <path
            d="M105.512 276.792L106.728 321.32H95.8484L89.4004 276.792H105.512Z"
            fill="#EEC1BB"
          />
          <path
            d="M94.344 318.2L108.472 318.44C108.73 318.446 108.978 318.539 109.176 318.705C109.374 318.871 109.509 319.099 109.56 319.352L111.928 330.888C112.028 331.378 111.931 331.887 111.659 332.306C111.386 332.725 110.96 333.02 110.472 333.128H110.072C104.968 332.952 100.472 332.6 94.072 332.488C86.584 332.36 88.472 333.288 79.672 333.272C74.376 333.272 73.512 327.208 75.752 326.952C86.072 325.832 87.192 322.744 91.224 319.128C92.1137 318.444 93.225 318.113 94.344 318.2Z"
            fill="#151027"
          />
          <path
            opacity="0.1"
            d="M106.392 309.08L105.512 276.792H89.4004L94.0884 309.112C97.5924 309.128 102.408 309.096 106.392 309.08Z"
            fill="black"
          />
          <path
            d="M203.832 170.536C203.832 170.536 207.608 205.064 172.488 206.68C137.368 208.296 109.944 212.312 109.144 224.808C108.344 237.304 109.144 300.968 109.144 300.968H90.0564C90.0564 300.968 82.6323 260.712 79.7363 235.752C76.9203 211.512 71.7363 193.928 96.6483 185.72C123.096 176.984 170.104 168.92 170.104 168.92L203.96 166.776L203.832 170.536Z"
            fill="#444052"
          />
          <path
            d="M111.96 298.344L110.76 304.792H89.8003L87.5923 298.344H111.96Z"
            fill="#FBC02C"
          />
          <path
            d="M211.4 71.48C211.4 71.48 211.4 63.704 195.672 64.6C178.968 65.56 182.12 73.016 182.12 73.016L211.4 71.48Z"
            fill="#FFFDE7"
          />
          <path
            opacity="0.3"
            d="M211.4 71.48C211.4 71.48 211.4 63.704 195.672 64.6C178.968 65.56 182.12 73.016 182.12 73.016L211.4 71.48Z"
            fill="#FFFDE7"
          />
          <path
            d="M226.056 106.36C225 121.736 225.368 167.992 225.368 167.992C225.368 167.992 191.768 170.2 165.4 169.336L162.344 80.3599C162.356 78.7867 162.842 77.2536 163.738 75.9606C164.634 74.6676 165.899 73.6749 167.368 73.1119C174.824 70.2159 192.328 66.9359 219.704 70.5359C229.144 71.7999 227.304 88.1839 226.056 106.36Z"
            fill="#FBC02C"
          />

          {/* Hand */}
          <path
            id="banner-web-hand"
            d="M167.736 105.768C167.736 105.768 154.68 138.088 141.928 141.576C129.176 145.064 109.928 142.232 109.928 142.232L103.976 143.832L98.1522 142.968H97.9442L91.3522 142.808C91.115 142.828 90.8771 142.779 90.6666 142.668C90.456 142.557 90.2816 142.388 90.1639 142.182C90.0461 141.975 89.99 141.738 90.0021 141.501C90.0142 141.263 90.094 141.034 90.2322 140.84L92.6002 137.64C92.7978 137.377 93.0715 137.182 93.3842 137.08L99.6402 135.064C99.8932 135.008 100.155 135.008 100.408 135.064L110.008 136.584C110.008 136.584 136.648 132.216 139.352 129.752C142.056 127.288 150.104 101.448 150.104 101.448L167.736 105.768Z"
            fill="#EEC1BB"
          />
          <animateTransform
            xlinkHref="#banner-web-hand"
            attributeName="transform"
            attributeType="XML"
            type="rotate"
            values="0; -2; 0;"
            dur="1s"
            repeatCount="indefinite"
          />
          <animateTransform
            xlinkHref="#banner-web-hand"
            attributeName="transform"
            attributeType="XML"
            type="translateY"
            values="0,0; 2,-2; 0,0;"
            dur="1s"
            repeatCount="indefinite"
          />

          <path
            opacity="0.1"
            d="M167.4 90.7279C167.4 90.7279 165.368 93.1439 162.904 96.6319L163.784 122.392C173.592 118.056 177.48 92.8079 177.48 92.8079L171.08 88.2959L167.4 90.7279Z"
            fill="black"
          />
          <path
            d="M175.608 73.752C166.136 70.648 152.792 77.768 147.688 107.592L167.368 113.336C167.368 113.336 189.144 78.2 175.608 73.752Z"
            fill="#FBC02C"
          />
          <path
            d="M188.136 223.432H173.336V266.808H188.136V223.432Z"
            fill="#263238"
          />
          <path
            opacity="0.6"
            d="M188.136 223.432H173.336V266.808H188.136V223.432Z"
            fill="white"
          />
          <path
            d="M190.424 306.104V251H171.032V306.104L126.888 312.232V318.36L180.728 313.768L234.568 318.36V312.232L190.424 306.104Z"
            fill="#151027"
          />
          <path
            d="M126.248 333.384C129.474 333.384 132.088 330.769 132.088 327.544C132.088 324.318 129.474 321.704 126.248 321.704C123.023 321.704 120.408 324.318 120.408 327.544C120.408 330.769 123.023 333.384 126.248 333.384Z"
            fill="#D0CFD4"
          />
          <path
            d="M234.568 333.384C237.793 333.384 240.408 330.769 240.408 327.544C240.408 324.318 237.793 321.704 234.568 321.704C231.343 321.704 228.728 324.318 228.728 327.544C228.728 330.769 231.343 333.384 234.568 333.384Z"
            fill="#D0CFD4"
          />
          <path
            d="M180.728 333.384C183.953 333.384 186.568 330.769 186.568 327.544C186.568 324.318 183.953 321.704 180.728 321.704C177.503 321.704 174.888 324.318 174.888 327.544C174.888 330.769 177.503 333.384 180.728 333.384Z"
            fill="#D0CFD4"
          />
          <path
            opacity="0.3"
            d="M188.136 223.432H173.336V234.152H188.136V223.432Z"
            fill="black"
          />
          <path
            d="M239.24 125.112H191.016C187.225 125.115 183.572 126.532 180.77 129.085C177.968 131.639 176.219 135.145 175.864 138.92L171.8 182.488C171.349 187.289 169.185 191.768 165.704 195.106C162.223 198.443 157.656 200.416 152.84 200.664L106.296 203C103.572 203.139 101.006 204.319 99.1273 206.296C97.2486 208.273 96.2007 210.896 96.2002 213.624V214.6C96.2002 216.938 97.129 219.18 98.7823 220.834C100.436 222.487 102.678 223.416 105.016 223.416H246.76L254.392 141.816C254.597 139.702 254.358 137.569 253.691 135.553C253.023 133.537 251.94 131.683 250.514 130.11C249.087 128.537 247.347 127.28 245.405 126.419C243.464 125.558 241.364 125.113 239.24 125.112Z"
            fill="#73707D"
          />
          <path
            d="M250.088 223.432H179.192L187.096 139C187.451 135.226 189.2 131.719 192.002 129.166C194.804 126.612 198.457 125.195 202.248 125.192H250.472C252.59 125.194 254.684 125.638 256.621 126.494C258.557 127.351 260.294 128.603 261.72 130.169C263.146 131.734 264.229 133.58 264.902 135.589C265.574 137.597 265.82 139.723 265.624 141.832L258.728 215.656C258.503 217.79 257.496 219.766 255.9 221.202C254.305 222.637 252.235 223.432 250.088 223.432Z"
            fill="#A19FA9"
          />
          <path
            d="M84.4719 332.728H15.5278C14.1523 332.73 12.79 332.461 11.5186 331.936C10.2472 331.411 9.09173 330.641 8.11836 329.669C7.14499 328.697 6.37276 327.543 5.8459 326.272C5.31903 325.002 5.04785 323.64 5.04785 322.264V163.736C5.04785 162.36 5.31903 160.998 5.8459 159.728C6.37276 158.457 7.14499 157.303 8.11836 156.331C9.09173 155.359 10.2472 154.589 11.5186 154.064C12.79 153.539 14.1523 153.27 15.5278 153.272H84.4719C85.2145 153.272 85.9267 153.567 86.4518 154.092C86.9769 154.617 87.2719 155.329 87.2719 156.072C87.2719 156.815 86.9769 157.527 86.4518 158.052C85.9267 158.577 85.2145 158.872 84.4719 158.872H15.5278C14.8908 158.861 14.258 158.978 13.6664 159.214C13.0748 159.451 12.5361 159.802 12.0819 160.249C11.6277 160.696 11.267 161.229 11.0208 161.816C10.7745 162.404 10.6478 163.035 10.6479 163.672V322.2C10.6478 322.837 10.7745 323.468 11.0208 324.056C11.267 324.643 11.6277 325.176 12.0819 325.623C12.5361 326.069 13.0748 326.421 13.6664 326.658C14.258 326.894 14.8908 327.011 15.5278 327H84.4719C85.2145 327 85.9267 327.295 86.4518 327.82C86.9769 328.345 87.2719 329.057 87.2719 329.8C87.2892 330.178 87.2296 330.556 87.0967 330.911C86.9637 331.265 86.7602 331.589 86.4985 331.863C86.2367 332.137 85.9221 332.355 85.5738 332.503C85.2255 332.652 84.8506 332.728 84.4719 332.728Z"
            fill="#263238"
          />
          <g opacity="0.5">
            <path
              opacity="0.5"
              d="M84.4719 332.728H15.5278C14.1523 332.73 12.79 332.461 11.5186 331.936C10.2472 331.411 9.09173 330.641 8.11836 329.669C7.14499 328.697 6.37276 327.543 5.8459 326.272C5.31903 325.002 5.04785 323.64 5.04785 322.264V163.736C5.04785 162.36 5.31903 160.998 5.8459 159.728C6.37276 158.457 7.14499 157.303 8.11836 156.331C9.09173 155.359 10.2472 154.589 11.5186 154.064C12.79 153.539 14.1523 153.27 15.5278 153.272H84.4719C85.2145 153.272 85.9267 153.567 86.4518 154.092C86.9769 154.617 87.2719 155.329 87.2719 156.072C87.2719 156.815 86.9769 157.527 86.4518 158.052C85.9267 158.577 85.2145 158.872 84.4719 158.872H15.5278C14.8908 158.861 14.258 158.978 13.6664 159.214C13.0748 159.451 12.5361 159.802 12.0819 160.249C11.6277 160.696 11.267 161.229 11.0208 161.816C10.7745 162.404 10.6478 163.035 10.6479 163.672V322.2C10.6478 322.837 10.7745 323.468 11.0208 324.056C11.267 324.643 11.6277 325.176 12.0819 325.623C12.5361 326.069 13.0748 326.421 13.6664 326.658C14.258 326.894 14.8908 327.011 15.5278 327H84.4719C85.2145 327 85.9267 327.295 86.4518 327.82C86.9769 328.345 87.2719 329.057 87.2719 329.8C87.2892 330.178 87.2296 330.556 87.0967 330.911C86.9637 331.265 86.7602 331.589 86.4985 331.863C86.2367 332.137 85.9221 332.355 85.5738 332.503C85.2255 332.652 84.8506 332.728 84.4719 332.728Z"
              fill="white"
            />
          </g>
          <path
            d="M38.9043 69.864L34.1042 66.664C33.982 66.5859 33.8814 66.4782 33.8118 66.351C33.7421 66.2238 33.7056 66.081 33.7056 65.936C33.7056 65.7909 33.7421 65.6482 33.8118 65.521C33.8814 65.3937 33.982 65.2861 34.1042 65.208L38.9043 62.0079C39.0806 61.8922 39.2956 61.8507 39.5024 61.8927C39.7091 61.9346 39.891 62.0566 40.0083 62.2319C40.1191 62.407 40.1577 62.6182 40.1159 62.8212C40.0741 63.0241 39.9552 63.2029 39.7842 63.3199L35.8003 65.96L39.7842 68.6C39.9552 68.7171 40.0741 68.8959 40.1159 69.0988C40.1577 69.3017 40.1191 69.5129 40.0083 69.688C39.8812 69.8523 39.6963 69.9621 39.4911 69.9948C39.286 70.0275 39.0761 69.9807 38.9043 69.864Z"
            fill="white"
          />
          <path
            d="M49.5279 69.6399C49.4322 69.4646 49.4071 69.2593 49.4577 69.066C49.5082 68.8727 49.6306 68.706 49.7999 68.5999L53.784 65.9599L49.7999 63.2719C49.6282 63.1551 49.5099 62.9749 49.4709 62.7709C49.4319 62.5669 49.4754 62.3558 49.5919 62.1839C49.6485 62.0976 49.7216 62.0233 49.807 61.9653C49.8923 61.9073 49.9884 61.8667 50.0894 61.8459C50.1905 61.8251 50.2947 61.8245 50.396 61.844C50.4974 61.8636 50.5938 61.903 50.6799 61.9599L55.48 65.1599C55.6022 65.238 55.7028 65.3457 55.7725 65.4729C55.8422 65.6001 55.8787 65.7428 55.8787 65.8879C55.8787 66.033 55.8422 66.1757 55.7725 66.3029C55.7028 66.4301 55.6022 66.5378 55.48 66.6159L50.6799 69.8159C50.594 69.8832 50.4952 69.9323 50.3896 69.9599C50.284 69.9876 50.1738 69.9934 50.0659 69.9769C49.958 69.9604 49.8546 69.922 49.7621 69.8641C49.6695 69.8061 49.5899 69.7298 49.5279 69.6399Z"
            fill="white"
          />
          <path
            d="M42.9521 71.8C42.853 71.7691 42.7609 71.7189 42.6814 71.6521C42.6018 71.5853 42.5363 71.5034 42.4887 71.4111C42.4411 71.3188 42.4122 71.218 42.4039 71.1144C42.3956 71.0109 42.4079 70.9068 42.4401 70.8081L45.7521 60.344C45.7813 60.2454 45.8299 60.1537 45.8951 60.0743C45.9603 59.9949 46.0409 59.9293 46.1319 59.8816C46.2229 59.8339 46.3226 59.8049 46.425 59.7963C46.5274 59.7878 46.6305 59.8 46.7281 59.832C46.8267 59.8611 46.9184 59.9098 46.9978 59.975C47.0773 60.0402 47.1428 60.1207 47.1905 60.2117C47.2383 60.3027 47.2672 60.4024 47.2758 60.5048C47.2843 60.6073 47.2722 60.7104 47.2401 60.808L43.9441 71.288C43.9132 71.3872 43.8629 71.4792 43.7962 71.5588C43.7294 71.6384 43.6475 71.7038 43.5552 71.7515C43.4629 71.7991 43.3621 71.8279 43.2585 71.8363C43.155 71.8446 43.0509 71.8323 42.9521 71.8Z"
            fill="white"
          />
          <path
            className="banner-web-line"
            d="M70.12 79.7999H34.488C34.3795 79.7999 34.272 79 34"
            stroke="#1D9B44"
          />
          <path
            className="banner-web-line"
            d="M111.048 79.7999H75.4003C75.2911 79.7999 75.1829 79 75"
            stroke="#1D9B44"
          />
          <path
            className="banner-web-line"
            d="M54.856 87.128H34.488C34.3795 87.128 34.272 87 34"
            stroke="#2D88E3"
          />
          <path
            className="banner-web-line"
            d="M93.5121 87.128H60.1521C60.0436 87.128 59.9362 87 59"
            stroke="#2D88E3"
          />
          <path
            className="banner-web-line"
            d="M88.76 94.4719H34.488C34.2701 94.4677 34.0626 94 33"
            stroke="#D61822"
          />
          <path
            className="banner-web-line"
            d="M105.4 94.4719H94.0723C93.8516 94.4719 93.64 94 93"
            stroke="#D61822"
          />
          <path
            className="banner-web-line"
            d="M59.832 101.8H34.488C34.3795 101.8 34.272 101 34"
            stroke="#FBC02C"
          />
          <path
            className="banner-web-line"
            d="M96.68 101.8H65.144C64.9233 101.8 64.7117 101 64"
            stroke="#FBC02C"
          />
          <path
            className="banner-web-line"
            d="M70.12 109.128H34.488C34.3795 109.128 34.272 109 34"
            stroke="#FBC02C"
          />
          <path
            className="banner-web-line"
            d="M100.568 109.128H75.4003C75.1797 109.128 74.968 109 74"
            stroke="#FBC02C"
          />
        </svg>
      )}
    </Wrap>
  );
};

export default Web;

const aniLine = keyframes`
  0% {
    stroke-dashoffset: 100;
  }
  100% {
    stroke-dashoffset: 0;
  }
`;
const aniPerson = keyframes`
  0%{
    right: -100px;
    opacity: 0;
  }

  100%{
    opacity: 1;
    right: 9.38%;
  }
`;
const Wrap = styled.div`
  z-index: 8;

  div {
    position: absolute;
  }

  svg#banner-web-man {
    position: absolute;
    width: 265px;
    height: auto;
    bottom: 5px;
    opacity: 0;
    animation: ${aniPerson} 0.8s ease 0.5s forwards;
  }

  svg#banner-web-icon-1 {
    position: absolute;
    bottom: 15%;
    left: 10%;
  }

  svg#banner-web-mobile {
    position: absolute;
    bottom: 59px;
    left: calc(50% + 4px);
    transform: translateX(-50%);
  }

  svg#banner-web-icon-2 {
    position: absolute;
    bottom: 50%;
    left: 3%;
  }

  svg#banner_web_circle_icon {
    position: absolute;
    top: 7%;
    left: 5%;
  }

  #banner_web_icon_home {
    transform-origin: 109px 60px;
  }
  #banner_web_icon_text {
    transform-origin: 189px 60px;
  }
  #banner_web_icon_search {
    transform-origin: 149px 349px;
  }

  #banner_web_circle_item_1 {
    transform-origin: 30% 60%;
  }
  #banner_web_circle_item_2 {
    transform-origin: 40% 50%;
  }
  #banner_web_circle_item_3 {
    transform-origin: 50% 20%;
  }
  #banner_web_circle_item_4 {
    transform-origin: 60% 20%;
  }
  #banner_web_circle_item_5 {
    transform-origin: 70% 30%;
  }

  svg#banner-web-icon-4 {
    position: absolute;
    top: 10%;
    right: 25%;
  }

  .banner-web-line {
    stroke-dasharray: 100;
    stroke-dashoffset: 100;
    animation: ${aniLine} 2s linear 0.4s;
    animation-iteration-count: infinite;
  }
`;
